/******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId])
/******/ 			return installedModules[moduleId].exports;
/******/
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			exports: {},
/******/ 			id: moduleId,
/******/ 			loaded: false
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.loaded = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(0);
/******/ })
/************************************************************************/
/******/ ([
/* 0 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var _init = __webpack_require__(1);
	
	var _init2 = _interopRequireDefault(_init);
	
	var _header = __webpack_require__(38);
	
	var _header2 = _interopRequireDefault(_header);
	
	var _modal = __webpack_require__(39);
	
	var _modal2 = _interopRequireDefault(_modal);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	// import accordionSecition from './sections/accordion';
	
	(0, _init2.default)();
	
	(0, _header2.default)();
	(0, _modal2.default)();
	// accordionSecition();

/***/ }),
/* 1 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.default = init;
	
	var _links = __webpack_require__(2);
	
	var _links2 = _interopRequireDefault(_links);
	
	var _tracking = __webpack_require__(4);
	
	var _tracking2 = _interopRequireDefault(_tracking);
	
	var _scroller = __webpack_require__(5);
	
	var _scroller2 = _interopRequireDefault(_scroller);
	
	var _toggler = __webpack_require__(7);
	
	var _toggler2 = _interopRequireDefault(_toggler);
	
	var _selector = __webpack_require__(11);
	
	var _selector2 = _interopRequireDefault(_selector);
	
	var _tracker = __webpack_require__(12);
	
	var _tracker2 = _interopRequireDefault(_tracker);
	
	var _autosize = __webpack_require__(13);
	
	var _autosize2 = _interopRequireDefault(_autosize);
	
	var _floatLabel = __webpack_require__(19);
	
	var _floatLabel2 = _interopRequireDefault(_floatLabel);
	
	var _validator = __webpack_require__(20);
	
	var _validator2 = _interopRequireDefault(_validator);
	
	var _lightbox = __webpack_require__(22);
	
	var _lightbox2 = _interopRequireDefault(_lightbox);
	
	var _playOnHover = __webpack_require__(24);
	
	var _playOnHover2 = _interopRequireDefault(_playOnHover);
	
	var _swiper = __webpack_require__(25);
	
	var _swiper2 = _interopRequireDefault(_swiper);
	
	var _fade = __webpack_require__(27);
	
	var _fade2 = _interopRequireDefault(_fade);
	
	var _lazyLoad = __webpack_require__(28);
	
	var _lazyLoad2 = _interopRequireDefault(_lazyLoad);
	
	var _parallax = __webpack_require__(30);
	
	var _parallax2 = _interopRequireDefault(_parallax);
	
	var _reveal = __webpack_require__(31);
	
	var _reveal2 = _interopRequireDefault(_reveal);
	
	var _sticky = __webpack_require__(33);
	
	var _sticky2 = _interopRequireDefault(_sticky);
	
	var _categorySelect = __webpack_require__(34);
	
	var _categorySelect2 = _interopRequireDefault(_categorySelect);
	
	var _shopForm = __webpack_require__(35);
	
	var _shopForm2 = _interopRequireDefault(_shopForm);
	
	var _selectAutoloader = __webpack_require__(36);
	
	var _selectAutoloader2 = _interopRequireDefault(_selectAutoloader);
	
	var _inspectScroll = __webpack_require__(37);
	
	var _inspectScroll2 = _interopRequireDefault(_inspectScroll);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function init() {
	    var context = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : document.body;
	
	    (0, _links2.default)(context);
	    (0, _tracking2.default)(context);
	    (0, _scroller2.default)(context);
	    (0, _toggler2.default)(context);
	    (0, _selector2.default)(context);
	    (0, _tracker2.default)(context);
	    (0, _autosize2.default)(context);
	    (0, _floatLabel2.default)(context);
	    (0, _validator2.default)(context);
	    (0, _lightbox2.default)(context);
	    (0, _playOnHover2.default)(context);
	    (0, _swiper2.default)(context);
	    (0, _fade2.default)(context);
	    (0, _lazyLoad2.default)(context);
	    (0, _parallax2.default)(context);
	    (0, _reveal2.default)(context);
	    (0, _sticky2.default)(context);
	    (0, _categorySelect2.default)(context);
	    (0, _shopForm2.default)(context);
	    (0, _selectAutoloader2.default)(context);
	    (0, _inspectScroll2.default)(context);
	}

/***/ }),
/* 2 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	exports.default = linksEnhancement;
	
	var _jquery = __webpack_require__(3);
	
	var _jquery2 = _interopRequireDefault(_jquery);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var assetExtensions = 'png jpg jpeg gif doc docx xls xlsx pdf ppt pptx'.split(' ');
	
	/**
	 * Improves the functionality of links depending on their URL's.
	 *
	 * @param context
	 */
	function linksEnhancement() {
		var context = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : document.body;
	
		var $context = (0, _jquery2.default)(context);
	
		$context.find('a').each(function () {
			var $a = (0, _jquery2.default)(this);
			var href = String($a.attr('href'));
	
			// Checks to make sure there are no `sw-*` properties on the element
			var cleanLink = Array.from(this.attributes).reduce(function (acc, a) {
				return acc && !/^sw-/.test(a.name);
			}, true);
	
			if (cleanLink) {
	
				// Animates scroll for anchor links
				if (href.startsWith('#')) {
					$a.attr('sw-scroller', JSON.stringify({ to: href }));
				}
	
				// Forces new window clicks for asset files
				var lowerHref = href.toLowerCase();
				var _iteratorNormalCompletion = true;
				var _didIteratorError = false;
				var _iteratorError = undefined;
	
				try {
					for (var _iterator = assetExtensions[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
						var ext = _step.value;
	
						if (lowerHref.endsWith('.' + ext)) {
							$a.attr('target', '_blank');
							break;
						}
					}
				} catch (err) {
					_didIteratorError = true;
					_iteratorError = err;
				} finally {
					try {
						if (!_iteratorNormalCompletion && _iterator.return) {
							_iterator.return();
						}
					} finally {
						if (_didIteratorError) {
							throw _iteratorError;
						}
					}
				}
			}
		});
	
		// Force no focusing on links just clicked. This ensures no focus outline shows up after clicking.
		$context.find('a, button').on('click', function () {
			(0, _jquery2.default)(this).trigger('blur');
		});
	}

/***/ }),
/* 3 */
/***/ (function(module, exports) {

	module.exports = jQuery;

/***/ }),
/* 4 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	exports.default = trackingEnhancement;
	
	var _jquery = __webpack_require__(3);
	
	var _jquery2 = _interopRequireDefault(_jquery);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * Enables automatic tracking on links and forms.
	 *
	 * @param context
	 */
	function trackingEnhancement() {
		var context = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : document.body;
	
		var $context = (0, _jquery2.default)(context);
	
		var trackingElements = [{ selector: 'a[href^="mailto:"]', label: "Email click" }, { selector: 'a[href^="tel:"]', label: "Phone click" }, { selector: 'form', label: "Form sent" }];
	
		trackingElements.forEach(function (_ref) {
			var selector = _ref.selector,
			    label = _ref.label;
	
			$context.find(selector).attr('sw-tracker', JSON.stringify({ label: label }));
		});
	}

/***/ }),
/* 5 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.default = scrollerDirective;
	
	var _jquery = __webpack_require__(3);
	
	var _jquery2 = _interopRequireDefault(_jquery);
	
	var _parse = __webpack_require__(6);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var $body = (0, _jquery2.default)('html, body');
	var docEl = document.documentElement;
	
	var breakable = true;
	var breakTimeout = null;
	var bound = false;
	
	/**
	 * Scrolls to a point on the page when an element is clicked.
	 *
	 * Scrolls to top: <button sw-scroller="top">Top</button>
	 * Scrolls to bottom: <button sw-scroller="bottom">Bottom</button>
	 * Scrolls to element by ID: <button sw-scroller="#element">Element</button>
	 *
	 * @param context
	 */
	function scrollerDirective() {
	    var context = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : document.body;
	
	    var $context = (0, _jquery2.default)(context);
	
	    $context.find('[sw-scroller]').each(function () {
	        var $element = (0, _jquery2.default)(this);
	        var json = $element.attr('sw-scroller');
	        var settings = (0, _parse.directiveSettings)(json, {
	            to: 'top',
	            selector: null,
	            speed: 500
	        }, 'to');
	
	        $element.on('click', function (e) {
	            e.preventDefault();
	
	            clearInterval(breakTimeout);
	            breakable = false;
	            breakTimeout = setTimeout(function () {
	                return breakable = true;
	            }, 100);
	
	            var top = 0;
	            switch (settings.to) {
	                case 'top':
	                    top = 0;break;
	                case 'bottom':
	                    top = docEl.scrollHeight - docEl.clientHeight;break;
	                case 'element':
	                    top = (0, _jquery2.default)(settings.selector).offset().top;break;
	                default:
	                    top = (0, _jquery2.default)(settings.to).offset().top;
	            }
	
	            $body.animate({ scrollTop: Math.min(top, docEl.scrollHeight - docEl.clientHeight) }, { duration: settings.speed });
	        });
	    });
	
	    if (!bound) {
	        bound = true;
	        $body.bind('scroll mousedown DOMMouseScroll mousewheel keyup touchstart', function (e) {
	            if (breakable && e.which > 0) {
	                switch (e.type) {
	                    case 'mousedown':
	                    case 'mousewheel':
	                    case 'touchstart':
	                        $body.stop();break;
	                }
	            }
	        });
	    }
	}

/***/ }),
/* 6 */
/***/ (function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.directiveSettings = directiveSettings;
	/**
	 * Parses the JSON from a directive.
	 *
	 * @param data
	 * @param defaults
	 * @param targetProperty
	 */
	function directiveSettings(data) {
	    var defaults = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
	    var targetProperty = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
	
	    var settings = Object.assign({}, defaults);
	
	    if (data) {
	        var parsedData = void 0;
	
	        try {
	            parsedData = JSON.parse(data);
	        } catch (e) {
	            parsedData = data;
	        }
	
	        if (parsedData instanceof Object && !Array.isArray(parsedData)) {
	            Object.assign(settings, parsedData);
	        } else if (targetProperty) {
	            settings[targetProperty] = parsedData;
	        } else {
	            console.error("Error parsing settings: \"" + data + "\"");
	        }
	    }
	
	    return settings;
	}

/***/ }),
/* 7 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.default = togglerDirective;
	
	var _jquery = __webpack_require__(3);
	
	var _jquery2 = _interopRequireDefault(_jquery);
	
	var _parse = __webpack_require__(6);
	
	var _toggler = __webpack_require__(8);
	
	var _toggler2 = _interopRequireDefault(_toggler);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * Toggles the visual display of an element on the page.
	 * Contains action directives for interacting with a toggler element:
	 *  - toggler-open
	 *  - toggler-close
	 *  - toggler-toggle
	 *
	 * @param context
	 */
	function togglerDirective() {
	    var context = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : document.body;
	
	    var $context = (0, _jquery2.default)(context);
	
	    $context.find('[sw-toggler]').each(function () {
	        var $element = (0, _jquery2.default)(this);
	        var json = $element.attr('sw-toggler');
	        var settings = (0, _parse.directiveSettings)(json, {
	            open: true,
	            transition: false
	        }, 'open');
	
	        var toggler = new _toggler2.default(this, settings);
	
	        $element.data('toggler', toggler);
	    });
	
	    var _loop = function _loop(action) {
	
	        $context.find('[sw-toggler-' + action + ']').each(function () {
	            var $element = (0, _jquery2.default)(this);
	            var json = $element.attr('sw-toggler-' + action);
	            var settings = (0, _parse.directiveSettings)(json, {
	                target: null,
	                on: 'click',
	                prevent: true
	            }, 'target');
	
	            $element.on(settings.on, function (e) {
	                var $target = settings.target ? (0, _jquery2.default)(settings.target) : $element.closest('[sw-toggler]');
	                var toggler = $target.data('toggler');
	
	                if (toggler) {
	                    toggler[action]();
	                }
	
	                if (settings.prevent) {
	                    e.preventDefault();
	                }
	            });
	        });
	    };
	
	    var _arr = ['open', 'close', 'toggle'];
	    for (var _i = 0; _i < _arr.length; _i++) {
	        var action = _arr[_i];
	        _loop(action);
	    }
	
	    $context.find('select[sw-toggler-select]').each(function () {
	        var $element = (0, _jquery2.default)(this);
	
	        var $options = $element.find('option');
	        var values = $options.toArray().map(function (el) {
	            return (0, _jquery2.default)(el).prop('value');
	        });
	        var togglers = values.map(function (v) {
	            return (0, _jquery2.default)(v).data('toggler');
	        });
	
	        togglers.forEach(function (toggler) {
	            if (toggler) {
	                var index = togglers.indexOf(toggler);
	                var value = values[index];
	
	                toggler.on('open', function () {
	                    return $element.val(value);
	                });
	            }
	        });
	
	        $element.on('change', function () {
	            var value = $element.val();
	            var index = values.indexOf(value);
	            var toggler = togglers[index];
	
	            toggler.open();
	        });
	    });
	
	    $context.find('[sw-toggler-class]').each(function () {
	        var $element = (0, _jquery2.default)(this);
	        var json = $element.attr('sw-toggler-class');
	        var settings = (0, _parse.directiveSettings)(json, {
	            target: null,
	            openClass: 'is-open',
	            closedClass: 'is-closed'
	        }, 'target');
	
	        var $target = settings.target ? (0, _jquery2.default)(settings.target) : $element.closest('[sw-toggler]');
	        var toggler = $target.data('toggler');
	
	        if (toggler) {
	            var updateClasses = function updateClasses() {
	                $element.removeClass(toggler.isOpen ? settings.closedClass : settings.openClass);
	                $element.addClass(toggler.isOpen ? settings.openClass : settings.closedClass);
	            };
	
	            toggler.on('toggle', updateClasses);
	            updateClasses();
	        }
	    });
	}

/***/ }),
/* 8 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.transitionTypes = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _jquery = __webpack_require__(3);
	
	var _jquery2 = _interopRequireDefault(_jquery);
	
	var _emitter = __webpack_require__(9);
	
	var _emitter2 = _interopRequireDefault(_emitter);
	
	var _drawing = __webpack_require__(10);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	/**
	 * Map of transition types.
	 */
	var transitionTypes = exports.transitionTypes = {
	
	    css: {
	        init: function init(toggler) {
	            toggler.$element[0].addEventListener('transitionend', function (e) {
	                if (e.target === toggler.$element[0]) {
	                    toggler.transitionEnd();
	                }
	            });
	        }
	    },
	
	    height: {
	        init: function init(toggler) {
	            toggler.$element.css('display', toggler.isOpen ? '' : 'none');
	        },
	        start: function start(toggler) {
	            if (toggler.isOpen) {
	                toggler.$element.slideDown(300, function () {
	                    return toggler.transitionEnd();
	                });
	            } else {
	                toggler.$element.slideUp(300, function () {
	                    return toggler.transitionEnd();
	                });
	            }
	        },
	        skip: function skip(toggler) {
	            toggler.$element.css('display', toggler.isOpen ? '' : 'none');
	        }
	    }
	};
	
	/**
	 * Toggler class for toggling the visual state of an element.
	 */
	
	var Toggler = function (_Emitter) {
	    _inherits(Toggler, _Emitter);
	
	    /**
	     *
	     * @param element
	     * @param settings
	     */
	    function Toggler(element) {
	        var settings = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
	
	        _classCallCheck(this, Toggler);
	
	        var _this = _possibleConstructorReturn(this, (Toggler.__proto__ || Object.getPrototypeOf(Toggler)).call(this));
	
	        _this.$element = (0, _jquery2.default)(element);
	        _this.isOpen = typeof settings.open === 'boolean' ? settings.open : true;
	        _this.transition = settings.transition in transitionTypes ? settings.transition : false;
	
	        _this.transitionInit();
	        return _this;
	    }
	
	    /**
	     *
	     * @param isOpen
	     * @param transition
	     */
	
	
	    _createClass(Toggler, [{
	        key: 'toggle',
	        value: function toggle(isOpen, transition) {
	            isOpen = typeof isOpen === 'boolean' ? isOpen : !this.isOpen;
	            transition = typeof transition === 'boolean' ? transition : true;
	
	            if (this.isOpen !== isOpen) {
	                this.isOpen = isOpen;
	
	                if (this.transition && transition) {
	
	                    this.transitionStart();
	                } else {
	
	                    this.$element.removeClass('is-before-opening is-opening is-before-closing is-closing').toggleClass('is-open', this.isOpen).toggleClass('is-closed', !this.isOpen);
	
	                    this.transitionSkip();
	                }
	
	                this.trigger('toggle');
	                this.trigger(this.isOpen ? 'open' : 'close');
	            }
	        }
	
	        /**
	         *
	         * @param transition
	         */
	
	    }, {
	        key: 'open',
	        value: function open(transition) {
	            this.toggle(true, transition);
	        }
	
	        /**
	         *
	         * @param transition
	         */
	
	    }, {
	        key: 'close',
	        value: function close(transition) {
	            this.toggle(false, transition);
	        }
	
	        /**
	         *
	         */
	
	    }, {
	        key: 'transitionInit',
	        value: function transitionInit() {
	            this.$element.removeClass('is-before-opening is-opening is-before-closing is-closing').toggleClass('is-open', this.isOpen).toggleClass('is-closed', !this.isOpen);
	
	            var transitionType = transitionTypes[this.transition];
	            if (transitionType && transitionType.init) {
	                transitionType.init(this);
	            }
	        }
	
	        /**
	         *
	         */
	
	    }, {
	        key: 'transitionStart',
	        value: function transitionStart() {
	
	            if (this.isOpen) {
	
	                if (this.$element.hasClass('is-before-closing')) {
	
	                    this.$element.removeClass('is-before-closing').addClass('is-open');
	                } else if (this.$element.hasClass('is-closing')) {
	
	                    this.$element.removeClass('is-before-closing is-closing').addClass('is-opening');
	                } else {
	
	                    this.$element.removeClass('is-closed').addClass('is-before-opening');
	
	                    (0, _drawing.redraw)(this.$element);
	
	                    this.$element.removeClass('is-before-opening').addClass('is-opening');
	                }
	            } else {
	
	                if (this.$element.hasClass('is-before-opening')) {
	
	                    this.$element.removeClass('is-before-opening').addClass('is-closed');
	                } else if (this.$element.hasClass('is-opening')) {
	
	                    this.$element.removeClass('is-opening').addClass('is-closing');
	                } else {
	
	                    this.$element.removeClass('is-open').addClass('is-before-closing');
	
	                    (0, _drawing.redraw)(this.$element);
	
	                    this.$element.removeClass('is-before-closing').addClass('is-closing');
	                }
	            }
	
	            var transitionType = transitionTypes[this.transition];
	            if (transitionType && transitionType.start) {
	                transitionType.start(this);
	            }
	
	            this.trigger('transitionStart');
	        }
	
	        /**
	         *
	         */
	
	    }, {
	        key: 'transitionEnd',
	        value: function transitionEnd() {
	            if (this.isOpen) {
	
	                this.$element.removeClass('is-opening').addClass('is-open');
	            } else {
	
	                this.$element.removeClass('is-closing').addClass('is-closed');
	            }
	
	            var transitionType = transitionTypes[this.transition];
	            if (transitionType && transitionType.end) {
	                transitionType.end(this);
	            }
	
	            this.trigger('transitionEnd');
	        }
	
	        /**
	         *
	         */
	
	    }, {
	        key: 'transitionSkip',
	        value: function transitionSkip() {
	            var transitionType = transitionTypes[this.transition];
	            if (transitionType && transitionType.skip) {
	                transitionType.skip(this);
	            }
	        }
	    }]);
	
	    return Toggler;
	}(_emitter2.default);
	
	exports.default = Toggler;

/***/ }),
/* 9 */
/***/ (function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var Emitter = function () {
	    function Emitter() {
	        _classCallCheck(this, Emitter);
	
	        this.events = {};
	    }
	
	    _createClass(Emitter, [{
	        key: "on",
	        value: function on(type, callback) {
	            if (!(type in this.events)) {
	                this.events[type] = [];
	            }
	            this.events[type].push(callback);
	        }
	    }, {
	        key: "off",
	        value: function off(type) {
	            var callback = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
	
	            if (callback && type in this.events) {
	                var newList = [];
	                var _iteratorNormalCompletion = true;
	                var _didIteratorError = false;
	                var _iteratorError = undefined;
	
	                try {
	                    for (var _iterator = this.events[type][Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
	                        var cb = _step.value;
	
	                        if (cb !== callback) {
	                            newList.push(cb);
	                        }
	                    }
	                } catch (err) {
	                    _didIteratorError = true;
	                    _iteratorError = err;
	                } finally {
	                    try {
	                        if (!_iteratorNormalCompletion && _iterator.return) {
	                            _iterator.return();
	                        }
	                    } finally {
	                        if (_didIteratorError) {
	                            throw _iteratorError;
	                        }
	                    }
	                }
	
	                this.events[type] = newList;
	            } else {
	                delete this.events[type];
	            }
	        }
	    }, {
	        key: "trigger",
	        value: function trigger(type) {
	            var event = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
	
	            if (type in this.events) {
	                event.type = type;
	                var _iteratorNormalCompletion2 = true;
	                var _didIteratorError2 = false;
	                var _iteratorError2 = undefined;
	
	                try {
	                    for (var _iterator2 = this.events[type][Symbol.iterator](), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
	                        var cb = _step2.value;
	
	                        cb.call(this, event);
	                    }
	                } catch (err) {
	                    _didIteratorError2 = true;
	                    _iteratorError2 = err;
	                } finally {
	                    try {
	                        if (!_iteratorNormalCompletion2 && _iterator2.return) {
	                            _iterator2.return();
	                        }
	                    } finally {
	                        if (_didIteratorError2) {
	                            throw _iteratorError2;
	                        }
	                    }
	                }
	            }
	        }
	    }]);
	
	    return Emitter;
	}();
	
	exports.default = Emitter;

/***/ }),
/* 10 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.frame = frame;
	exports.unframe = unframe;
	exports.redraw = redraw;
	
	var _jquery = __webpack_require__(3);
	
	var _jquery2 = _interopRequireDefault(_jquery);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * Requests an animation frame.
	 *
	 * @param callback
	 * @returns {*}
	 */
	function frame(callback) {
	    if (typeof requestAnimationFrame === 'undefined') {
	        return setTimeout(callback, 0);
	    }
	    return requestAnimationFrame(callback);
	}
	
	/**
	 * Cancels a frame request.
	 *
	 * @param id
	 */
	function unframe(id) {
	    if (typeof cancelAnimationFrame === 'undefined') {
	        return clearTimeout(id);
	    }
	    return cancelAnimationFrame(id);
	}
	
	/**
	 * Triggers a layout reflow for a specific element.
	 *
	 * @param element
	 */
	function redraw(element) {
	    if (element instanceof _jquery2.default) {
	        element = element[0];
	    }
	    // Accessing this property triggers a layout reflow
	    element.offsetWidth;
	}

/***/ }),
/* 11 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	exports.default = selectorDirective;
	
	var _jquery = __webpack_require__(3);
	
	var _jquery2 = _interopRequireDefault(_jquery);
	
	var _parse = __webpack_require__(6);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function selectorDirective() {
		var context = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : document.body;
	
		var $context = (0, _jquery2.default)(context);
	
		$context.find('[sw-selector]').each(function () {
			var $element = (0, _jquery2.default)(this);
			var json = $element.attr('sw-selector');
			var settings = (0, _parse.directiveSettings)(json, {
				selector: '> [sw-toggler]'
			}, 'selector');
	
			var $togglers = $element.find(settings.selector);
			var togglers = Array.from($togglers).map(function (el) {
				return (0, _jquery2.default)(el).data('toggler');
			});
	
			var selectToggler = function selectToggler(toggler) {
				var _iteratorNormalCompletion = true;
				var _didIteratorError = false;
				var _iteratorError = undefined;
	
				try {
					for (var _iterator = togglers[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
						var otherToggler = _step.value;
	
						if (otherToggler !== toggler) {
							otherToggler.close();
						}
					}
				} catch (err) {
					_didIteratorError = true;
					_iteratorError = err;
				} finally {
					try {
						if (!_iteratorNormalCompletion && _iterator.return) {
							_iterator.return();
						}
					} finally {
						if (_didIteratorError) {
							throw _iteratorError;
						}
					}
				}
			};
	
			togglers.forEach(function (toggler) {
				return toggler.on('open', function () {
					return selectToggler(toggler);
				});
			});
		});
	}

/***/ }),
/* 12 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	exports.default = trackerDirective;
	
	var _jquery = __webpack_require__(3);
	
	var _jquery2 = _interopRequireDefault(_jquery);
	
	var _parse = __webpack_require__(6);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 *
	 * @param type
	 * @param action
	 * @param label
	 * @param timeout
	 * @returns {*}
	 */
	function trackEvent() {
		var type = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'lead';
		var action = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'click';
		var label = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : '';
		var timeout = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 1000;
	
		var promises = [];
	
		// Google Analytics
		if (typeof ga === 'function') {
	
			promises.push(new Promise(function (resolve, reject) {
	
				ga('send', {
					hitType: 'event',
					eventCategory: type,
					eventAction: action,
					eventLabel: label,
					hitCallback: function hitCallback() {
						return resolve();
					}
				});
	
				setTimeout(function () {
					return reject();
				}, timeout);
			}));
		}
	
		// Facebook Pixel
		if (typeof fqb === 'function') {
	
			promises.push(new Promise(function (resolve, reject) {
	
				fbq('track', 'Lead');
				resolve();
	
				// Facebook Pixel has no callback...
				// setTimeout(() => reject(), timeout);
			}));
		}
	
		return Promise.all(promises);
	}
	
	/**
	 *
	 * @param context
	 */
	function trackerDirective() {
		var context = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : document.body;
	
		var $context = (0, _jquery2.default)(context);
	
		$context.find('[sw-tracker]').each(function () {
			var _this = this;
	
			var $element = (0, _jquery2.default)(this);
			var json = $element.attr('sw-tracker');
			var settings = (0, _parse.directiveSettings)(json, {
				on: 'auto',
				type: 'lead',
				label: '',
				timeout: 1000
			}, 'label');
	
			if (settings.on === 'auto') {
				if ($element.is('form')) {
					settings.on = 'submit';
				} else {
					settings.on = 'click';
				}
			}
	
			$element.on(settings.on + '.tracker', function (e) {
				e.preventDefault();
				e.stopImmediatePropagation();
	
				var trigger = function trigger() {
					$element.off('.tracker');
					$element.trigger(settings.on);
	
					if (settings.on === 'click' && $element.is('a[href]')) {
						_this.click();
					}
				};
	
				trackEvent(settings.type, settings.on, settings.label, settings.timeout).then(trigger).catch(trigger);
			});
		});
	}

/***/ }),
/* 13 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = autosizeDirective;
	
	var _jquery = __webpack_require__(3);
	
	var _jquery2 = _interopRequireDefault(_jquery);
	
	var _autosize = __webpack_require__(14);
	
	var _autosize2 = _interopRequireDefault(_autosize);
	
	var _iframeResizer = __webpack_require__(15);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * Enhances textarea fields by automatically expanding it's height to fit it's contents.
	 *
	 * @see https://github.com/jackmoore/autosize
	 * @param context
	 */
	function autosizeDirective() {
	  var context = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : document.body;
	
	  var $context = (0, _jquery2.default)(context);
	
	  (0, _autosize2.default)($context.find('textarea[sw-autosize]'));
	
	  $context.find('iframe[sw-autosize]').each(function () {
	    (0, _iframeResizer.iframeResizer)({ checkOrigin: false }, this);
	  });
	}

/***/ }),
/* 14 */
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/*!
		Autosize 3.0.21
		license: MIT
		http://www.jacklmoore.com/autosize
	*/
	(function (global, factory) {
		if (true) {
			!(__WEBPACK_AMD_DEFINE_ARRAY__ = [exports, module], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
		} else if (typeof exports !== 'undefined' && typeof module !== 'undefined') {
			factory(exports, module);
		} else {
			var mod = {
				exports: {}
			};
			factory(mod.exports, mod);
			global.autosize = mod.exports;
		}
	})(this, function (exports, module) {
		'use strict';
	
		var map = typeof Map === "function" ? new Map() : (function () {
			var keys = [];
			var values = [];
	
			return {
				has: function has(key) {
					return keys.indexOf(key) > -1;
				},
				get: function get(key) {
					return values[keys.indexOf(key)];
				},
				set: function set(key, value) {
					if (keys.indexOf(key) === -1) {
						keys.push(key);
						values.push(value);
					}
				},
				'delete': function _delete(key) {
					var index = keys.indexOf(key);
					if (index > -1) {
						keys.splice(index, 1);
						values.splice(index, 1);
					}
				}
			};
		})();
	
		var createEvent = function createEvent(name) {
			return new Event(name, { bubbles: true });
		};
		try {
			new Event('test');
		} catch (e) {
			// IE does not support `new Event()`
			createEvent = function (name) {
				var evt = document.createEvent('Event');
				evt.initEvent(name, true, false);
				return evt;
			};
		}
	
		function assign(ta) {
			if (!ta || !ta.nodeName || ta.nodeName !== 'TEXTAREA' || map.has(ta)) return;
	
			var heightOffset = null;
			var clientWidth = ta.clientWidth;
			var cachedHeight = null;
	
			function init() {
				var style = window.getComputedStyle(ta, null);
	
				if (style.resize === 'vertical') {
					ta.style.resize = 'none';
				} else if (style.resize === 'both') {
					ta.style.resize = 'horizontal';
				}
	
				if (style.boxSizing === 'content-box') {
					heightOffset = -(parseFloat(style.paddingTop) + parseFloat(style.paddingBottom));
				} else {
					heightOffset = parseFloat(style.borderTopWidth) + parseFloat(style.borderBottomWidth);
				}
				// Fix when a textarea is not on document body and heightOffset is Not a Number
				if (isNaN(heightOffset)) {
					heightOffset = 0;
				}
	
				update();
			}
	
			function changeOverflow(value) {
				{
					// Chrome/Safari-specific fix:
					// When the textarea y-overflow is hidden, Chrome/Safari do not reflow the text to account for the space
					// made available by removing the scrollbar. The following forces the necessary text reflow.
					var width = ta.style.width;
					ta.style.width = '0px';
					// Force reflow:
					/* jshint ignore:start */
					ta.offsetWidth;
					/* jshint ignore:end */
					ta.style.width = width;
				}
	
				ta.style.overflowY = value;
			}
	
			function getParentOverflows(el) {
				var arr = [];
	
				while (el && el.parentNode && el.parentNode instanceof Element) {
					if (el.parentNode.scrollTop) {
						arr.push({
							node: el.parentNode,
							scrollTop: el.parentNode.scrollTop
						});
					}
					el = el.parentNode;
				}
	
				return arr;
			}
	
			function resize() {
				var originalHeight = ta.style.height;
				var overflows = getParentOverflows(ta);
				var docTop = document.documentElement && document.documentElement.scrollTop; // Needed for Mobile IE (ticket #240)
	
				ta.style.height = 'auto';
	
				var endHeight = ta.scrollHeight + heightOffset;
	
				if (ta.scrollHeight === 0) {
					// If the scrollHeight is 0, then the element probably has display:none or is detached from the DOM.
					ta.style.height = originalHeight;
					return;
				}
	
				ta.style.height = endHeight + 'px';
	
				// used to check if an update is actually necessary on window.resize
				clientWidth = ta.clientWidth;
	
				// prevents scroll-position jumping
				overflows.forEach(function (el) {
					el.node.scrollTop = el.scrollTop;
				});
	
				if (docTop) {
					document.documentElement.scrollTop = docTop;
				}
			}
	
			function update() {
				resize();
	
				var styleHeight = Math.round(parseFloat(ta.style.height));
				var computed = window.getComputedStyle(ta, null);
	
				// Using offsetHeight as a replacement for computed.height in IE, because IE does not account use of border-box
				var actualHeight = computed.boxSizing === 'content-box' ? Math.round(parseFloat(computed.height)) : ta.offsetHeight;
	
				// The actual height not matching the style height (set via the resize method) indicates that
				// the max-height has been exceeded, in which case the overflow should be allowed.
				if (actualHeight !== styleHeight) {
					if (computed.overflowY === 'hidden') {
						changeOverflow('scroll');
						resize();
						actualHeight = computed.boxSizing === 'content-box' ? Math.round(parseFloat(window.getComputedStyle(ta, null).height)) : ta.offsetHeight;
					}
				} else {
					// Normally keep overflow set to hidden, to avoid flash of scrollbar as the textarea expands.
					if (computed.overflowY !== 'hidden') {
						changeOverflow('hidden');
						resize();
						actualHeight = computed.boxSizing === 'content-box' ? Math.round(parseFloat(window.getComputedStyle(ta, null).height)) : ta.offsetHeight;
					}
				}
	
				if (cachedHeight !== actualHeight) {
					cachedHeight = actualHeight;
					var evt = createEvent('autosize:resized');
					try {
						ta.dispatchEvent(evt);
					} catch (err) {
						// Firefox will throw an error on dispatchEvent for a detached element
						// https://bugzilla.mozilla.org/show_bug.cgi?id=889376
					}
				}
			}
	
			var pageResize = function pageResize() {
				if (ta.clientWidth !== clientWidth) {
					update();
				}
			};
	
			var destroy = (function (style) {
				window.removeEventListener('resize', pageResize, false);
				ta.removeEventListener('input', update, false);
				ta.removeEventListener('keyup', update, false);
				ta.removeEventListener('autosize:destroy', destroy, false);
				ta.removeEventListener('autosize:update', update, false);
	
				Object.keys(style).forEach(function (key) {
					ta.style[key] = style[key];
				});
	
				map['delete'](ta);
			}).bind(ta, {
				height: ta.style.height,
				resize: ta.style.resize,
				overflowY: ta.style.overflowY,
				overflowX: ta.style.overflowX,
				wordWrap: ta.style.wordWrap
			});
	
			ta.addEventListener('autosize:destroy', destroy, false);
	
			// IE9 does not fire onpropertychange or oninput for deletions,
			// so binding to onkeyup to catch most of those events.
			// There is no way that I know of to detect something like 'cut' in IE9.
			if ('onpropertychange' in ta && 'oninput' in ta) {
				ta.addEventListener('keyup', update, false);
			}
	
			window.addEventListener('resize', pageResize, false);
			ta.addEventListener('input', update, false);
			ta.addEventListener('autosize:update', update, false);
			ta.style.overflowX = 'hidden';
			ta.style.wordWrap = 'break-word';
	
			map.set(ta, {
				destroy: destroy,
				update: update
			});
	
			init();
		}
	
		function destroy(ta) {
			var methods = map.get(ta);
			if (methods) {
				methods.destroy();
			}
		}
	
		function update(ta) {
			var methods = map.get(ta);
			if (methods) {
				methods.update();
			}
		}
	
		var autosize = null;
	
		// Do nothing in Node.js environment and IE8 (or lower)
		if (typeof window === 'undefined' || typeof window.getComputedStyle !== 'function') {
			autosize = function (el) {
				return el;
			};
			autosize.destroy = function (el) {
				return el;
			};
			autosize.update = function (el) {
				return el;
			};
		} else {
			autosize = function (el, options) {
				if (el) {
					Array.prototype.forEach.call(el.length ? el : [el], function (x) {
						return assign(x, options);
					});
				}
				return el;
			};
			autosize.destroy = function (el) {
				if (el) {
					Array.prototype.forEach.call(el.length ? el : [el], destroy);
				}
				return el;
			};
			autosize.update = function (el) {
				if (el) {
					Array.prototype.forEach.call(el.length ? el : [el], update);
				}
				return el;
			};
		}
	
		module.exports = autosize;
	});

/***/ }),
/* 15 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict'
	
	module.exports = __webpack_require__(16)


/***/ }),
/* 16 */
/***/ (function(module, exports, __webpack_require__) {

	exports.iframeResizer = __webpack_require__(17);
	exports.iframeResizerContentWindow = __webpack_require__(18);


/***/ }),
/* 17 */
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/*
	 * File: iframeResizer.js
	 * Desc: Force iframes to size to content.
	 * Requires: iframeResizer.contentWindow.js to be loaded into the target frame.
	 * Doc: https://github.com/davidjbradshaw/iframe-resizer
	 * Author: David J. Bradshaw - dave@bradshaw.net
	 * Contributor: Jure Mav - jure.mav@gmail.com
	 * Contributor: Reed Dadoune - reed@dadoune.com
	 */
	
	(function(undefined) {
	  'use strict';
	
	  if (typeof window === 'undefined') return; // don't run for server side render
	
	  var count = 0,
	    logEnabled = false,
	    hiddenCheckEnabled = false,
	    msgHeader = 'message',
	    msgHeaderLen = msgHeader.length,
	    msgId = '[iFrameSizer]', //Must match iframe msg ID
	    msgIdLen = msgId.length,
	    pagePosition = null,
	    requestAnimationFrame = window.requestAnimationFrame,
	    resetRequiredMethods = {
	      max: 1,
	      scroll: 1,
	      bodyScroll: 1,
	      documentElementScroll: 1
	    },
	    settings = {},
	    timer = null,
	    logId = 'Host Page',
	    defaults = {
	      autoResize: true,
	      bodyBackground: null,
	      bodyMargin: null,
	      bodyMarginV1: 8,
	      bodyPadding: null,
	      checkOrigin: true,
	      inPageLinks: false,
	      enablePublicMethods: true,
	      heightCalculationMethod: 'bodyOffset',
	      id: 'iFrameResizer',
	      interval: 32,
	      log: false,
	      maxHeight: Infinity,
	      maxWidth: Infinity,
	      minHeight: 0,
	      minWidth: 0,
	      resizeFrom: 'parent',
	      scrolling: false,
	      sizeHeight: true,
	      sizeWidth: false,
	      warningTimeout: 5000,
	      tolerance: 0,
	      widthCalculationMethod: 'scroll',
	      closedCallback: function() {},
	      initCallback: function() {},
	      messageCallback: function() {
	        warn('MessageCallback function not defined');
	      },
	      resizedCallback: function() {},
	      scrollCallback: function() {
	        return true;
	      }
	    };
	
	  function getMutationObserver() {
	    return window.MutationObserver || window.WebKitMutationObserver || window.MozMutationObserver;
	  }
	
	  function addEventListener(obj, evt, func) {
	    /* istanbul ignore else */ // Not testable in PhantonJS
	    if ('addEventListener' in window) {
	      obj.addEventListener(evt, func, false);
	    } else if ('attachEvent' in window) {
	      //IE
	      obj.attachEvent('on' + evt, func);
	    }
	  }
	
	  function removeEventListener(el, evt, func) {
	    /* istanbul ignore else */ // Not testable in phantonJS
	    if ('removeEventListener' in window) {
	      el.removeEventListener(evt, func, false);
	    } else if ('detachEvent' in window) {
	      //IE
	      el.detachEvent('on' + evt, func);
	    }
	  }
	
	  function setupRequestAnimationFrame() {
	    var vendors = ['moz', 'webkit', 'o', 'ms'],
	      x;
	
	    // Remove vendor prefixing if prefixed and break early if not
	    for (x = 0; x < vendors.length && !requestAnimationFrame; x += 1) {
	      requestAnimationFrame = window[vendors[x] + 'RequestAnimationFrame'];
	    }
	
	    if (!requestAnimationFrame) {
	      log('setup', 'RequestAnimationFrame not supported');
	    }
	  }
	
	  function getMyID(iframeId) {
	    var retStr = 'Host page: ' + iframeId;
	
	    if (window.top !== window.self) {
	      if (window.parentIFrame && window.parentIFrame.getId) {
	        retStr = window.parentIFrame.getId() + ': ' + iframeId;
	      } else {
	        retStr = 'Nested host page: ' + iframeId;
	      }
	    }
	
	    return retStr;
	  }
	
	  function formatLogHeader(iframeId) {
	    return msgId + '[' + getMyID(iframeId) + ']';
	  }
	
	  function isLogEnabled(iframeId) {
	    return settings[iframeId] ? settings[iframeId].log : logEnabled;
	  }
	
	  function log(iframeId, msg) {
	    output('log', iframeId, msg, isLogEnabled(iframeId));
	  }
	
	  function info(iframeId, msg) {
	    output('info', iframeId, msg, isLogEnabled(iframeId));
	  }
	
	  function warn(iframeId, msg) {
	    output('warn', iframeId, msg, true);
	  }
	
	  function output(type, iframeId, msg, enabled) {
	    if (true === enabled && 'object' === typeof window.console) {
	      console[type](formatLogHeader(iframeId), msg);
	    }
	  }
	
	  function iFrameListener(event) {
	    function resizeIFrame() {
	      function resize() {
	        setSize(messageData);
	        setPagePosition(iframeId);
	        callback('resizedCallback', messageData);
	      }
	
	      ensureInRange('Height');
	      ensureInRange('Width');
	
	      syncResize(resize, messageData, 'init');
	    }
	
	    function processMsg() {
	      var data = msg.substr(msgIdLen).split(':');
	
	      return {
	        iframe: settings[data[0]] && settings[data[0]].iframe,
	        id: data[0],
	        height: data[1],
	        width: data[2],
	        type: data[3]
	      };
	    }
	
	    function ensureInRange(Dimension) {
	      var max = Number(settings[iframeId]['max' + Dimension]),
	        min = Number(settings[iframeId]['min' + Dimension]),
	        dimension = Dimension.toLowerCase(),
	        size = Number(messageData[dimension]);
	
	      log(
	        iframeId,
	        'Checking ' + dimension + ' is in range ' + min + '-' + max
	      );
	
	      if (size < min) {
	        size = min;
	        log(iframeId, 'Set ' + dimension + ' to min value');
	      }
	
	      if (size > max) {
	        size = max;
	        log(iframeId, 'Set ' + dimension + ' to max value');
	      }
	
	      messageData[dimension] = '' + size;
	    }
	
	    function isMessageFromIFrame() {
	      function checkAllowedOrigin() {
	        function checkList() {
	          var i = 0,
	            retCode = false;
	
	          log(
	            iframeId,
	            'Checking connection is from allowed list of origins: ' +
	              checkOrigin
	          );
	
	          for (; i < checkOrigin.length; i++) {
	            if (checkOrigin[i] === origin) {
	              retCode = true;
	              break;
	            }
	          }
	          return retCode;
	        }
	
	        function checkSingle() {
	          var remoteHost = settings[iframeId] && settings[iframeId].remoteHost;
	          log(iframeId, 'Checking connection is from: ' + remoteHost);
	          return origin === remoteHost;
	        }
	
	        return checkOrigin.constructor === Array ? checkList() : checkSingle();
	      }
	
	      var origin = event.origin,
	        checkOrigin = settings[iframeId] && settings[iframeId].checkOrigin;
	
	      if (checkOrigin && '' + origin !== 'null' && !checkAllowedOrigin()) {
	        throw new Error(
	          'Unexpected message received from: ' +
	            origin +
	            ' for ' +
	            messageData.iframe.id +
	            '. Message was: ' +
	            event.data +
	            '. This error can be disabled by setting the checkOrigin: false option or by providing of array of trusted domains.'
	        );
	      }
	
	      return true;
	    }
	
	    function isMessageForUs() {
	      return (
	        msgId === ('' + msg).substr(0, msgIdLen) &&
	        msg.substr(msgIdLen).split(':')[0] in settings
	      ); //''+Protects against non-string msg
	    }
	
	    function isMessageFromMetaParent() {
	      //Test if this message is from a parent above us. This is an ugly test, however, updating
	      //the message format would break backwards compatibity.
	      var retCode = messageData.type in { true: 1, false: 1, undefined: 1 };
	
	      if (retCode) {
	        log(iframeId, 'Ignoring init message from meta parent page');
	      }
	
	      return retCode;
	    }
	
	    function getMsgBody(offset) {
	      return msg.substr(msg.indexOf(':') + msgHeaderLen + offset);
	    }
	
	    function forwardMsgFromIFrame(msgBody) {
	      log(
	        iframeId,
	        'MessageCallback passed: {iframe: ' +
	          messageData.iframe.id +
	          ', message: ' +
	          msgBody +
	          '}'
	      );
	      callback('messageCallback', {
	        iframe: messageData.iframe,
	        message: JSON.parse(msgBody)
	      });
	      log(iframeId, '--');
	    }
	
	    function getPageInfo() {
	      var bodyPosition = document.body.getBoundingClientRect(),
	        iFramePosition = messageData.iframe.getBoundingClientRect();
	
	      return JSON.stringify({
	        iframeHeight: iFramePosition.height,
	        iframeWidth: iFramePosition.width,
	        clientHeight: Math.max(
	          document.documentElement.clientHeight,
	          window.innerHeight || 0
	        ),
	        clientWidth: Math.max(
	          document.documentElement.clientWidth,
	          window.innerWidth || 0
	        ),
	        offsetTop: parseInt(iFramePosition.top - bodyPosition.top, 10),
	        offsetLeft: parseInt(iFramePosition.left - bodyPosition.left, 10),
	        scrollTop: window.pageYOffset,
	        scrollLeft: window.pageXOffset
	      });
	    }
	
	    function sendPageInfoToIframe(iframe, iframeId) {
	      function debouncedTrigger() {
	        trigger(
	          'Send Page Info',
	          'pageInfo:' + getPageInfo(),
	          iframe,
	          iframeId
	        );
	      }
	      debounceFrameEvents(debouncedTrigger, 32, iframeId);
	    }
	
	    function startPageInfoMonitor() {
	      function setListener(type, func) {
	        function sendPageInfo() {
	          if (settings[id]) {
	            sendPageInfoToIframe(settings[id].iframe, id);
	          } else {
	            stop();
	          }
	        }
	
	        ['scroll', 'resize'].forEach(function(evt) {
	          log(id, type + evt + ' listener for sendPageInfo');
	          func(window, evt, sendPageInfo);
	        });
	      }
	
	      function stop() {
	        setListener('Remove ', removeEventListener);
	      }
	
	      function start() {
	        setListener('Add ', addEventListener);
	      }
	
	      var id = iframeId; //Create locally scoped copy of iFrame ID
	
	      start();
	
	      if (settings[id]) {
	        settings[id].stopPageInfo = stop;
	      }
	    }
	
	    function stopPageInfoMonitor() {
	      if (settings[iframeId] && settings[iframeId].stopPageInfo) {
	        settings[iframeId].stopPageInfo();
	        delete settings[iframeId].stopPageInfo;
	      }
	    }
	
	    function checkIFrameExists() {
	      var retBool = true;
	
	      if (null === messageData.iframe) {
	        warn(iframeId, 'IFrame (' + messageData.id + ') not found');
	        retBool = false;
	      }
	      return retBool;
	    }
	
	    function getElementPosition(target) {
	      var iFramePosition = target.getBoundingClientRect();
	
	      getPagePosition(iframeId);
	
	      return {
	        x: Math.floor(Number(iFramePosition.left) + Number(pagePosition.x)),
	        y: Math.floor(Number(iFramePosition.top) + Number(pagePosition.y))
	      };
	    }
	
	    function scrollRequestFromChild(addOffset) {
	      /* istanbul ignore next */ //Not testable in Karma
	      function reposition() {
	        pagePosition = newPosition;
	        scrollTo();
	        log(iframeId, '--');
	      }
	
	      function calcOffset() {
	        return {
	          x: Number(messageData.width) + offset.x,
	          y: Number(messageData.height) + offset.y
	        };
	      }
	
	      function scrollParent() {
	        if (window.parentIFrame) {
	          window.parentIFrame['scrollTo' + (addOffset ? 'Offset' : '')](
	            newPosition.x,
	            newPosition.y
	          );
	        } else {
	          warn(
	            iframeId,
	            'Unable to scroll to requested position, window.parentIFrame not found'
	          );
	        }
	      }
	
	      var offset = addOffset
	          ? getElementPosition(messageData.iframe)
	          : { x: 0, y: 0 },
	        newPosition = calcOffset();
	
	      log(
	        iframeId,
	        'Reposition requested from iFrame (offset x:' +
	          offset.x +
	          ' y:' +
	          offset.y +
	          ')'
	      );
	
	      if (window.top !== window.self) {
	        scrollParent();
	      } else {
	        reposition();
	      }
	    }
	
	    function scrollTo() {
	      if (false !== callback('scrollCallback', pagePosition)) {
	        setPagePosition(iframeId);
	      } else {
	        unsetPagePosition();
	      }
	    }
	
	    function findTarget(location) {
	      function jumpToTarget() {
	        var jumpPosition = getElementPosition(target);
	
	        log(
	          iframeId,
	          'Moving to in page link (#' +
	            hash +
	            ') at x: ' +
	            jumpPosition.x +
	            ' y: ' +
	            jumpPosition.y
	        );
	        pagePosition = {
	          x: jumpPosition.x,
	          y: jumpPosition.y
	        };
	
	        scrollTo();
	        log(iframeId, '--');
	      }
	
	      function jumpToParent() {
	        if (window.parentIFrame) {
	          window.parentIFrame.moveToAnchor(hash);
	        } else {
	          log(
	            iframeId,
	            'In page link #' +
	              hash +
	              ' not found and window.parentIFrame not found'
	          );
	        }
	      }
	
	      var hash = location.split('#')[1] || '',
	        hashData = decodeURIComponent(hash),
	        target =
	          document.getElementById(hashData) ||
	          document.getElementsByName(hashData)[0];
	
	      if (target) {
	        jumpToTarget();
	      } else if (window.top !== window.self) {
	        jumpToParent();
	      } else {
	        log(iframeId, 'In page link #' + hash + ' not found');
	      }
	    }
	
	    function callback(funcName, val) {
	      return chkCallback(iframeId, funcName, val);
	    }
	
	    function actionMsg() {
	      if (settings[iframeId] && settings[iframeId].firstRun) firstRun();
	
	      switch (messageData.type) {
	        case 'close':
	          if (settings[iframeId].closeRequestCallback)
	            chkCallback(
	              iframeId,
	              'closeRequestCallback',
	              settings[iframeId].iframe
	            );
	          else closeIFrame(messageData.iframe);
	          break;
	        case 'message':
	          forwardMsgFromIFrame(getMsgBody(6));
	          break;
	        case 'scrollTo':
	          scrollRequestFromChild(false);
	          break;
	        case 'scrollToOffset':
	          scrollRequestFromChild(true);
	          break;
	        case 'pageInfo':
	          sendPageInfoToIframe(
	            settings[iframeId] && settings[iframeId].iframe,
	            iframeId
	          );
	          startPageInfoMonitor();
	          break;
	        case 'pageInfoStop':
	          stopPageInfoMonitor();
	          break;
	        case 'inPageLink':
	          findTarget(getMsgBody(9));
	          break;
	        case 'reset':
	          resetIFrame(messageData);
	          break;
	        case 'init':
	          resizeIFrame();
	          callback('initCallback', messageData.iframe);
	          break;
	        default:
	          resizeIFrame();
	      }
	    }
	
	    function hasSettings(iframeId) {
	      var retBool = true;
	
	      if (!settings[iframeId]) {
	        retBool = false;
	        warn(
	          messageData.type +
	            ' No settings for ' +
	            iframeId +
	            '. Message was: ' +
	            msg
	        );
	      }
	
	      return retBool;
	    }
	
	    function iFrameReadyMsgReceived() {
	      for (var iframeId in settings) {
	        trigger(
	          'iFrame requested init',
	          createOutgoingMsg(iframeId),
	          document.getElementById(iframeId),
	          iframeId
	        );
	      }
	    }
	
	    function firstRun() {
	      if (settings[iframeId]) {
	        settings[iframeId].firstRun = false;
	      }
	    }
	
	    function clearWarningTimeout() {
	      if (settings[iframeId]) {
	        clearTimeout(settings[iframeId].msgTimeout);
	        settings[iframeId].warningTimeout = 0;
	      }
	    }
	
	    var msg = event.data,
	      messageData = {},
	      iframeId = null;
	
	    if ('[iFrameResizerChild]Ready' === msg) {
	      iFrameReadyMsgReceived();
	    } else if (isMessageForUs()) {
	      messageData = processMsg();
	      iframeId = logId = messageData.id;
	      if (settings[iframeId]) {
	        settings[iframeId].loaded = true;
	      }
	
	      if (!isMessageFromMetaParent() && hasSettings(iframeId)) {
	        log(iframeId, 'Received: ' + msg);
	
	        if (checkIFrameExists() && isMessageFromIFrame()) {
	          actionMsg();
	        }
	      }
	    } else {
	      info(iframeId, 'Ignored: ' + msg);
	    }
	  }
	
	  function chkCallback(iframeId, funcName, val) {
	    var func = null,
	      retVal = null;
	
	    if (settings[iframeId]) {
	      func = settings[iframeId][funcName];
	
	      if ('function' === typeof func) {
	        retVal = func(val);
	      } else {
	        throw new TypeError(
	          funcName + ' on iFrame[' + iframeId + '] is not a function'
	        );
	      }
	    }
	
	    return retVal;
	  }
	
	  function removeIframeListeners(iframe) {
	    var iframeId = iframe.id;
	    delete settings[iframeId];
	  }
	
	  function closeIFrame(iframe) {
	    var iframeId = iframe.id;
	    log(iframeId, 'Removing iFrame: ' + iframeId);
	
	    try {
	      // Catch race condition error with React
	      if (iframe.parentNode) {
	        iframe.parentNode.removeChild(iframe);
	      }
	    } catch (e) {}
	
	    chkCallback(iframeId, 'closedCallback', iframeId);
	    log(iframeId, '--');
	    removeIframeListeners(iframe);
	  }
	
	  function getPagePosition(iframeId) {
	    if (null === pagePosition) {
	      pagePosition = {
	        x:
	          window.pageXOffset !== undefined
	            ? window.pageXOffset
	            : document.documentElement.scrollLeft,
	        y:
	          window.pageYOffset !== undefined
	            ? window.pageYOffset
	            : document.documentElement.scrollTop
	      };
	      log(
	        iframeId,
	        'Get page position: ' + pagePosition.x + ',' + pagePosition.y
	      );
	    }
	  }
	
	  function setPagePosition(iframeId) {
	    if (null !== pagePosition) {
	      window.scrollTo(pagePosition.x, pagePosition.y);
	      log(
	        iframeId,
	        'Set page position: ' + pagePosition.x + ',' + pagePosition.y
	      );
	      unsetPagePosition();
	    }
	  }
	
	  function unsetPagePosition() {
	    pagePosition = null;
	  }
	
	  function resetIFrame(messageData) {
	    function reset() {
	      setSize(messageData);
	      trigger('reset', 'reset', messageData.iframe, messageData.id);
	    }
	
	    log(
	      messageData.id,
	      'Size reset requested by ' +
	        ('init' === messageData.type ? 'host page' : 'iFrame')
	    );
	    getPagePosition(messageData.id);
	    syncResize(reset, messageData, 'reset');
	  }
	
	  function setSize(messageData) {
	    function setDimension(dimension) {
	      if (!messageData.id) {
	        log('undefined', 'messageData id not set');
	        return;
	      }
	      messageData.iframe.style[dimension] = messageData[dimension] + 'px';
	      log(
	        messageData.id,
	        'IFrame (' +
	          iframeId +
	          ') ' +
	          dimension +
	          ' set to ' +
	          messageData[dimension] +
	          'px'
	      );
	    }
	
	    function chkZero(dimension) {
	      //FireFox sets dimension of hidden iFrames to zero.
	      //So if we detect that set up an event to check for
	      //when iFrame becomes visible.
	
	      /* istanbul ignore next */ //Not testable in PhantomJS
	      if (!hiddenCheckEnabled && '0' === messageData[dimension]) {
	        hiddenCheckEnabled = true;
	        log(iframeId, 'Hidden iFrame detected, creating visibility listener');
	        fixHiddenIFrames();
	      }
	    }
	
	    function processDimension(dimension) {
	      setDimension(dimension);
	      chkZero(dimension);
	    }
	
	    var iframeId = messageData.iframe.id;
	
	    if (settings[iframeId]) {
	      if (settings[iframeId].sizeHeight) {
	        processDimension('height');
	      }
	      if (settings[iframeId].sizeWidth) {
	        processDimension('width');
	      }
	    }
	  }
	
	  function syncResize(func, messageData, doNotSync) {
	    /* istanbul ignore if */ //Not testable in PhantomJS
	    if (doNotSync !== messageData.type && requestAnimationFrame) {
	      log(messageData.id, 'Requesting animation frame');
	      requestAnimationFrame(func);
	    } else {
	      func();
	    }
	  }
	
	  function trigger(calleeMsg, msg, iframe, id, noResponseWarning) {
	    function postMessageToIFrame() {
	      var target = settings[id] && settings[id].targetOrigin;
	      log(
	        id,
	        '[' +
	          calleeMsg +
	          '] Sending msg to iframe[' +
	          id +
	          '] (' +
	          msg +
	          ') targetOrigin: ' +
	          target
	      );
	      iframe.contentWindow.postMessage(msgId + msg, target);
	    }
	
	    function iFrameNotFound() {
	      warn(id, '[' + calleeMsg + '] IFrame(' + id + ') not found');
	    }
	
	    function chkAndSend() {
	      if (
	        iframe &&
	        'contentWindow' in iframe &&
	        null !== iframe.contentWindow
	      ) {
	        //Null test for PhantomJS
	        postMessageToIFrame();
	      } else {
	        iFrameNotFound();
	      }
	    }
	
	    function warnOnNoResponse() {
	      function warning() {
	        if (settings[id] && !settings[id].loaded && !errorShown) {
	          errorShown = true;
	          warn(
	            id,
	            'IFrame has not responded within ' +
	              settings[id].warningTimeout / 1000 +
	              ' seconds. Check iFrameResizer.contentWindow.js has been loaded in iFrame. This message can be ignored if everything is working, or you can set the warningTimeout option to a higher value or zero to suppress this warning.'
	          );
	        }
	      }
	
	      if (
	        !!noResponseWarning &&
	        settings[id] &&
	        !!settings[id].warningTimeout
	      ) {
	        settings[id].msgTimeout = setTimeout(
	          warning,
	          settings[id].warningTimeout
	        );
	      }
	    }
	
	    var errorShown = false;
	
	    id = id || iframe.id;
	
	    if (settings[id]) {
	      chkAndSend();
	      warnOnNoResponse();
	    }
	  }
	
	  function createOutgoingMsg(iframeId) {
	    return (
	      iframeId +
	      ':' +
	      settings[iframeId].bodyMarginV1 +
	      ':' +
	      settings[iframeId].sizeWidth +
	      ':' +
	      settings[iframeId].log +
	      ':' +
	      settings[iframeId].interval +
	      ':' +
	      settings[iframeId].enablePublicMethods +
	      ':' +
	      settings[iframeId].autoResize +
	      ':' +
	      settings[iframeId].bodyMargin +
	      ':' +
	      settings[iframeId].heightCalculationMethod +
	      ':' +
	      settings[iframeId].bodyBackground +
	      ':' +
	      settings[iframeId].bodyPadding +
	      ':' +
	      settings[iframeId].tolerance +
	      ':' +
	      settings[iframeId].inPageLinks +
	      ':' +
	      settings[iframeId].resizeFrom +
	      ':' +
	      settings[iframeId].widthCalculationMethod
	    );
	  }
	
	  function setupIFrame(iframe, options) {
	    function setLimits() {
	      function addStyle(style) {
	        if (
	          Infinity !== settings[iframeId][style] &&
	          0 !== settings[iframeId][style]
	        ) {
	          iframe.style[style] = settings[iframeId][style] + 'px';
	          log(
	            iframeId,
	            'Set ' + style + ' = ' + settings[iframeId][style] + 'px'
	          );
	        }
	      }
	
	      function chkMinMax(dimension) {
	        if (
	          settings[iframeId]['min' + dimension] >
	          settings[iframeId]['max' + dimension]
	        ) {
	          throw new Error(
	            'Value for min' +
	              dimension +
	              ' can not be greater than max' +
	              dimension
	          );
	        }
	      }
	
	      chkMinMax('Height');
	      chkMinMax('Width');
	
	      addStyle('maxHeight');
	      addStyle('minHeight');
	      addStyle('maxWidth');
	      addStyle('minWidth');
	    }
	
	    function newId() {
	      var id = (options && options.id) || defaults.id + count++;
	      if (null !== document.getElementById(id)) {
	        id = id + count++;
	      }
	      return id;
	    }
	
	    function ensureHasId(iframeId) {
	      logId = iframeId;
	      if ('' === iframeId) {
	        iframe.id = iframeId = newId();
	        logEnabled = (options || {}).log;
	        logId = iframeId;
	        log(
	          iframeId,
	          'Added missing iframe ID: ' + iframeId + ' (' + iframe.src + ')'
	        );
	      }
	
	      return iframeId;
	    }
	
	    function setScrolling() {
	      log(
	        iframeId,
	        'IFrame scrolling ' +
	          (settings[iframeId] && settings[iframeId].scrolling
	            ? 'enabled'
	            : 'disabled') +
	          ' for ' +
	          iframeId
	      );
	      iframe.style.overflow =
	        false === (settings[iframeId] && settings[iframeId].scrolling)
	          ? 'hidden'
	          : 'auto';
	      switch (settings[iframeId] && settings[iframeId].scrolling) {
	        case 'omit':
	          break;
	        case true:
	          iframe.scrolling = 'yes';
	          break;
	        case false:
	          iframe.scrolling = 'no';
	          break;
	        default:
	          iframe.scrolling = settings[iframeId]
	            ? settings[iframeId].scrolling
	            : 'no';
	      }
	    }
	
	    //The V1 iFrame script expects an int, where as in V2 expects a CSS
	    //string value such as '1px 3em', so if we have an int for V2, set V1=V2
	    //and then convert V2 to a string PX value.
	    function setupBodyMarginValues() {
	      if (
	        'number' ===
	          typeof (settings[iframeId] && settings[iframeId].bodyMargin) ||
	        '0' === (settings[iframeId] && settings[iframeId].bodyMargin)
	      ) {
	        settings[iframeId].bodyMarginV1 = settings[iframeId].bodyMargin;
	        settings[iframeId].bodyMargin =
	          '' + settings[iframeId].bodyMargin + 'px';
	      }
	    }
	
	    function checkReset() {
	      // Reduce scope of firstRun to function, because IE8's JS execution
	      // context stack is borked and this value gets externally
	      // changed midway through running this function!!!
	      var firstRun = settings[iframeId] && settings[iframeId].firstRun,
	        resetRequertMethod =
	          settings[iframeId] &&
	          settings[iframeId].heightCalculationMethod in resetRequiredMethods;
	
	      if (!firstRun && resetRequertMethod) {
	        resetIFrame({ iframe: iframe, height: 0, width: 0, type: 'init' });
	      }
	    }
	
	    function setupIFrameObject() {
	      if (Function.prototype.bind && settings[iframeId]) {
	        //Ignore unpolyfilled IE8.
	        settings[iframeId].iframe.iFrameResizer = {
	          close: closeIFrame.bind(null, settings[iframeId].iframe),
	
	          removeListeners: removeIframeListeners.bind(
	            null,
	            settings[iframeId].iframe
	          ),
	
	          resize: trigger.bind(
	            null,
	            'Window resize',
	            'resize',
	            settings[iframeId].iframe
	          ),
	
	          moveToAnchor: function(anchor) {
	            trigger(
	              'Move to anchor',
	              'moveToAnchor:' + anchor,
	              settings[iframeId].iframe,
	              iframeId
	            );
	          },
	
	          sendMessage: function(message) {
	            message = JSON.stringify(message);
	            trigger(
	              'Send Message',
	              'message:' + message,
	              settings[iframeId].iframe,
	              iframeId
	            );
	          }
	        };
	      }
	    }
	
	    //We have to call trigger twice, as we can not be sure if all
	    //iframes have completed loading when this code runs. The
	    //event listener also catches the page changing in the iFrame.
	    function init(msg) {
	      function iFrameLoaded() {
	        trigger('iFrame.onload', msg, iframe, undefined, true);
	        checkReset();
	      }
	
	      function createDestroyObserver(MutationObserver) {
	        if (!iframe.parentNode) {
	          return;
	        }
	
	        var destroyObserver = new MutationObserver(function (mutations) {
	          mutations.forEach(function (mutation) {
	            var removedNodes = Array.prototype.slice.call(mutation.removedNodes); // Transform NodeList into an Array
	            removedNodes.forEach(function (removedNode) {
	              if (removedNode === iframe) {
	                closeIFrame(iframe);
	              }
	            });
	          });
	        });
	        destroyObserver.observe(iframe.parentNode, {
	          childList: true
	        });
	      }
	
	      var MutationObserver = getMutationObserver();
	      if (MutationObserver) {
	        createDestroyObserver(MutationObserver);
	      }
	
	      addEventListener(iframe, 'load', iFrameLoaded);
	      trigger('init', msg, iframe, undefined, true);
	    }
	
	    function checkOptions(options) {
	      if ('object' !== typeof options) {
	        throw new TypeError('Options is not an object');
	      }
	    }
	
	    function copyOptions(options) {
	      for (var option in defaults) {
	        if (defaults.hasOwnProperty(option)) {
	          settings[iframeId][option] = options.hasOwnProperty(option)
	            ? options[option]
	            : defaults[option];
	        }
	      }
	    }
	
	    function getTargetOrigin(remoteHost) {
	      return '' === remoteHost || 'file://' === remoteHost ? '*' : remoteHost;
	    }
	
	    function processOptions(options) {
	      options = options || {};
	      settings[iframeId] = {
	        firstRun: true,
	        iframe: iframe,
	        remoteHost: iframe.src
	          .split('/')
	          .slice(0, 3)
	          .join('/')
	      };
	
	      checkOptions(options);
	      copyOptions(options);
	
	      if (settings[iframeId]) {
	        settings[iframeId].targetOrigin =
	          true === settings[iframeId].checkOrigin
	            ? getTargetOrigin(settings[iframeId].remoteHost)
	            : '*';
	      }
	    }
	
	    function beenHere() {
	      return iframeId in settings && 'iFrameResizer' in iframe;
	    }
	
	    var iframeId = ensureHasId(iframe.id);
	
	    if (!beenHere()) {
	      processOptions(options);
	      setScrolling();
	      setLimits();
	      setupBodyMarginValues();
	      init(createOutgoingMsg(iframeId));
	      setupIFrameObject();
	    } else {
	      warn(iframeId, 'Ignored iFrame, already setup.');
	    }
	  }
	
	  function debouce(fn, time) {
	    if (null === timer) {
	      timer = setTimeout(function() {
	        timer = null;
	        fn();
	      }, time);
	    }
	  }
	
	  var frameTimer = {};
	  function debounceFrameEvents(fn, time, frameId) {
	    if (!frameTimer[frameId]) {
	      frameTimer[frameId] = setTimeout(function() {
	        frameTimer[frameId] = null;
	        fn();
	      }, time);
	    }
	  } //Not testable in PhantomJS
	
	  /* istanbul ignore next */ function fixHiddenIFrames() {
	    function checkIFrames() {
	      function checkIFrame(settingId) {
	        function chkDimension(dimension) {
	          return (
	            '0px' ===
	            (settings[settingId] && settings[settingId].iframe.style[dimension])
	          );
	        }
	
	        function isVisible(el) {
	          return null !== el.offsetParent;
	        }
	
	        if (
	          settings[settingId] &&
	          isVisible(settings[settingId].iframe) &&
	          (chkDimension('height') || chkDimension('width'))
	        ) {
	          trigger(
	            'Visibility change',
	            'resize',
	            settings[settingId].iframe,
	            settingId
	          );
	        }
	      }
	
	      for (var settingId in settings) {
	        checkIFrame(settingId);
	      }
	    }
	
	    function mutationObserved(mutations) {
	      log(
	        'window',
	        'Mutation observed: ' + mutations[0].target + ' ' + mutations[0].type
	      );
	      debouce(checkIFrames, 16);
	    }
	
	    function createMutationObserver() {
	      var target = document.querySelector('body'),
	        config = {
	          attributes: true,
	          attributeOldValue: false,
	          characterData: true,
	          characterDataOldValue: false,
	          childList: true,
	          subtree: true
	        },
	        observer = new MutationObserver(mutationObserved);
	
	      observer.observe(target, config);
	    }
	
	    var MutationObserver = getMutationObserver();
	    if (MutationObserver) {
	      createMutationObserver();
	    }
	  }
	
	  function resizeIFrames(event) {
	    function resize() {
	      sendTriggerMsg('Window ' + event, 'resize');
	    }
	
	    log('window', 'Trigger event: ' + event);
	    debouce(resize, 16);
	  } //Not testable in PhantomJS
	
	  /* istanbul ignore next */ function tabVisible() {
	    function resize() {
	      sendTriggerMsg('Tab Visable', 'resize');
	    }
	
	    if ('hidden' !== document.visibilityState) {
	      log('document', 'Trigger event: Visiblity change');
	      debouce(resize, 16);
	    }
	  }
	
	  function sendTriggerMsg(eventName, event) {
	    function isIFrameResizeEnabled(iframeId) {
	      return (
	        settings[iframeId] &&
	        'parent' === settings[iframeId].resizeFrom &&
	        settings[iframeId].autoResize &&
	        !settings[iframeId].firstRun
	      );
	    }
	
	    for (var iframeId in settings) {
	      if (isIFrameResizeEnabled(iframeId)) {
	        trigger(eventName, event, document.getElementById(iframeId), iframeId);
	      }
	    }
	  }
	
	  function setupEventListeners() {
	    addEventListener(window, 'message', iFrameListener);
	
	    addEventListener(window, 'resize', function() {
	      resizeIFrames('resize');
	    });
	
	    addEventListener(document, 'visibilitychange', tabVisible);
	    addEventListener(document, '-webkit-visibilitychange', tabVisible); //Andriod 4.4
	    addEventListener(window, 'focusin', function() {
	      resizeIFrames('focus');
	    }); //IE8-9
	    addEventListener(window, 'focus', function() {
	      resizeIFrames('focus');
	    });
	  }
	
	  function factory() {
	    function init(options, element) {
	      function chkType() {
	        if (!element.tagName) {
	          throw new TypeError('Object is not a valid DOM element');
	        } else if ('IFRAME' !== element.tagName.toUpperCase()) {
	          throw new TypeError(
	            'Expected <IFRAME> tag, found <' + element.tagName + '>'
	          );
	        }
	      }
	
	      if (element) {
	        chkType();
	        setupIFrame(element, options);
	        iFrames.push(element);
	      }
	    }
	
	    function warnDeprecatedOptions(options) {
	      if (options && options.enablePublicMethods) {
	        warn(
	          'enablePublicMethods option has been removed, public methods are now always available in the iFrame'
	        );
	      }
	    }
	
	    var iFrames;
	
	    setupRequestAnimationFrame();
	    setupEventListeners();
	
	    return function iFrameResizeF(options, target) {
	      iFrames = []; //Only return iFrames past in on this call
	
	      warnDeprecatedOptions(options);
	
	      switch (typeof target) {
	        case 'undefined':
	        case 'string':
	          Array.prototype.forEach.call(
	            document.querySelectorAll(target || 'iframe'),
	            init.bind(undefined, options)
	          );
	          break;
	        case 'object':
	          init(options, target);
	          break;
	        default:
	          throw new TypeError('Unexpected data type (' + typeof target + ')');
	      }
	
	      return iFrames;
	    };
	  }
	
	  function createJQueryPublicMethod($) {
	    if (!$.fn) {
	      info('', 'Unable to bind to jQuery, it is not fully loaded.');
	    } else if (!$.fn.iFrameResize) {
	      $.fn.iFrameResize = function $iFrameResizeF(options) {
	        function init(index, element) {
	          setupIFrame(element, options);
	        }
	
	        return this.filter('iframe')
	          .each(init)
	          .end();
	      };
	    }
	  }
	
	  if (window.jQuery) {
	    createJQueryPublicMethod(window.jQuery);
	  }
	
	  if (true) {
	    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	  } else if (typeof module === 'object' && typeof module.exports === 'object') {
	    //Node for browserfy
	    module.exports = factory();
	  }
	  window.iFrameResize = window.iFrameResize || factory();
	})();


/***/ }),
/* 18 */
/***/ (function(module, exports) {

	/*
	 * File: iframeResizer.contentWindow.js
	 * Desc: Include this file in any page being loaded into an iframe
	 *       to force the iframe to resize to the content size.
	 * Requires: iframeResizer.js on host page.
	 * Doc: https://github.com/davidjbradshaw/iframe-resizer
	 * Author: David J. Bradshaw - dave@bradshaw.net
	 * Contributor: Jure Mav - jure.mav@gmail.com
	 * Contributor: Ian Caunce - ian@hallnet.co.uk
	 */
	
	(function(undefined) {
	  'use strict';
	
	  if (typeof window === 'undefined') return; // don't run for server side render
	
	  var autoResize = true,
	    base = 10,
	    bodyBackground = '',
	    bodyMargin = 0,
	    bodyMarginStr = '',
	    bodyObserver = null,
	    bodyPadding = '',
	    calculateWidth = false,
	    doubleEventList = { resize: 1, click: 1 },
	    eventCancelTimer = 128,
	    firstRun = true,
	    height = 1,
	    heightCalcModeDefault = 'bodyOffset',
	    heightCalcMode = heightCalcModeDefault,
	    initLock = true,
	    initMsg = '',
	    inPageLinks = {},
	    interval = 32,
	    intervalTimer = null,
	    logging = false,
	    msgID = '[iFrameSizer]', //Must match host page msg ID
	    msgIdLen = msgID.length,
	    myID = '',
	    observer = null,
	    resetRequiredMethods = {
	      max: 1,
	      min: 1,
	      bodyScroll: 1,
	      documentElementScroll: 1
	    },
	    resizeFrom = 'child',
	    sendPermit = true,
	    target = window.parent,
	    targetOriginDefault = '*',
	    tolerance = 0,
	    triggerLocked = false,
	    triggerLockedTimer = null,
	    throttledTimer = 16,
	    width = 1,
	    widthCalcModeDefault = 'scroll',
	    widthCalcMode = widthCalcModeDefault,
	    win = window,
	    messageCallback = function() {
	      warn('MessageCallback function not defined');
	    },
	    readyCallback = function() {},
	    pageInfoCallback = function() {},
	    customCalcMethods = {
	      height: function() {
	        warn('Custom height calculation function not defined');
	        return document.documentElement.offsetHeight;
	      },
	      width: function() {
	        warn('Custom width calculation function not defined');
	        return document.body.scrollWidth;
	      }
	    },
	    eventHandlersByName = {},
	    passiveSupported = false,
	    onceSupported = false;
	
	  function noop() {}
	
	  try {
	    var options = Object.create(
	      {},
	      {
	        passive: {
	          get: function() {
	            passiveSupported = true;
	          }
	        },
	        once: {
	          get: function() {
	            onceSupported = true;
	          }
	        }
	      }
	    );
	    window.addEventListener('test', noop, options);
	    window.removeEventListener('test', noop, options);
	  } catch (e) {
	    /* */
	  }
	
	  function addEventListener(el, evt, func, options) {
	    /* istanbul ignore else */ // Not testable in phantomJS
	    if ('addEventListener' in window) {
	      el.addEventListener(evt, func, passiveSupported ? options || {} : false);
	    } else if ('attachEvent' in window) {
	      //IE
	      el.attachEvent('on' + evt, func);
	    }
	  }
	
	  function removeEventListener(el, evt, func) {
	    /* istanbul ignore else */ // Not testable in phantomJS
	    if ('removeEventListener' in window) {
	      el.removeEventListener(evt, func, false);
	    } else if ('detachEvent' in window) {
	      //IE
	      el.detachEvent('on' + evt, func);
	    }
	  }
	
	  function capitalizeFirstLetter(string) {
	    return string.charAt(0).toUpperCase() + string.slice(1);
	  }
	
	  //Based on underscore.js
	  function throttle(func) {
	    var context,
	      args,
	      result,
	      timeout = null,
	      previous = 0,
	      later = function() {
	        previous = getNow();
	        timeout = null;
	        result = func.apply(context, args);
	        if (!timeout) {
	          context = args = null;
	        }
	      };
	
	    return function() {
	      var now = getNow();
	
	      if (!previous) {
	        previous = now;
	      }
	
	      var remaining = throttledTimer - (now - previous);
	
	      context = this;
	      args = arguments;
	
	      if (remaining <= 0 || remaining > throttledTimer) {
	        if (timeout) {
	          clearTimeout(timeout);
	          timeout = null;
	        }
	
	        previous = now;
	        result = func.apply(context, args);
	
	        if (!timeout) {
	          context = args = null;
	        }
	      } else if (!timeout) {
	        timeout = setTimeout(later, remaining);
	      }
	
	      return result;
	    };
	  }
	
	  var getNow =
	    Date.now ||
	    function() {
	      /* istanbul ignore next */ // Not testable in PhantonJS
	      return new Date().getTime();
	    };
	
	  function formatLogMsg(msg) {
	    return msgID + '[' + myID + ']' + ' ' + msg;
	  }
	
	  function log(msg) {
	    if (logging && 'object' === typeof window.console) {
	      console.log(formatLogMsg(msg));
	    }
	  }
	
	  function warn(msg) {
	    if ('object' === typeof window.console) {
	      console.warn(formatLogMsg(msg));
	    }
	  }
	
	  function init() {
	    readDataFromParent();
	    log('Initialising iFrame (' + location.href + ')');
	    readDataFromPage();
	    setMargin();
	    setBodyStyle('background', bodyBackground);
	    setBodyStyle('padding', bodyPadding);
	    injectClearFixIntoBodyElement();
	    checkHeightMode();
	    checkWidthMode();
	    stopInfiniteResizingOfIFrame();
	    setupPublicMethods();
	    startEventListeners();
	    inPageLinks = setupInPageLinks();
	    sendSize('init', 'Init message from host page');
	    readyCallback();
	  }
	
	  function readDataFromParent() {
	    function strBool(str) {
	      return 'true' === str ? true : false;
	    }
	
	    var data = initMsg.substr(msgIdLen).split(':');
	
	    myID = data[0];
	    bodyMargin = undefined !== data[1] ? Number(data[1]) : bodyMargin; //For V1 compatibility
	    calculateWidth = undefined !== data[2] ? strBool(data[2]) : calculateWidth;
	    logging = undefined !== data[3] ? strBool(data[3]) : logging;
	    interval = undefined !== data[4] ? Number(data[4]) : interval;
	    autoResize = undefined !== data[6] ? strBool(data[6]) : autoResize;
	    bodyMarginStr = data[7];
	    heightCalcMode = undefined !== data[8] ? data[8] : heightCalcMode;
	    bodyBackground = data[9];
	    bodyPadding = data[10];
	    tolerance = undefined !== data[11] ? Number(data[11]) : tolerance;
	    inPageLinks.enable = undefined !== data[12] ? strBool(data[12]) : false;
	    resizeFrom = undefined !== data[13] ? data[13] : resizeFrom;
	    widthCalcMode = undefined !== data[14] ? data[14] : widthCalcMode;
	  }
	
	  function readDataFromPage() {
	    function readData() {
	      var data = window.iFrameResizer;
	
	      log('Reading data from page: ' + JSON.stringify(data));
	
	      messageCallback =
	        'messageCallback' in data ? data.messageCallback : messageCallback;
	      readyCallback =
	        'readyCallback' in data ? data.readyCallback : readyCallback;
	      targetOriginDefault =
	        'targetOrigin' in data ? data.targetOrigin : targetOriginDefault;
	      heightCalcMode =
	        'heightCalculationMethod' in data
	          ? data.heightCalculationMethod
	          : heightCalcMode;
	      widthCalcMode =
	        'widthCalculationMethod' in data
	          ? data.widthCalculationMethod
	          : widthCalcMode;
	    }
	
	    function setupCustomCalcMethods(calcMode, calcFunc) {
	      if ('function' === typeof calcMode) {
	        log('Setup custom ' + calcFunc + 'CalcMethod');
	        customCalcMethods[calcFunc] = calcMode;
	        calcMode = 'custom';
	      }
	
	      return calcMode;
	    }
	
	    if (
	      'iFrameResizer' in window &&
	      Object === window.iFrameResizer.constructor
	    ) {
	      readData();
	      heightCalcMode = setupCustomCalcMethods(heightCalcMode, 'height');
	      widthCalcMode = setupCustomCalcMethods(widthCalcMode, 'width');
	    }
	
	    log('TargetOrigin for parent set to: ' + targetOriginDefault);
	  }
	
	  function chkCSS(attr, value) {
	    if (-1 !== value.indexOf('-')) {
	      warn('Negative CSS value ignored for ' + attr);
	      value = '';
	    }
	    return value;
	  }
	
	  function setBodyStyle(attr, value) {
	    if (undefined !== value && '' !== value && 'null' !== value) {
	      document.body.style[attr] = value;
	      log('Body ' + attr + ' set to "' + value + '"');
	    }
	  }
	
	  function setMargin() {
	    //If called via V1 script, convert bodyMargin from int to str
	    if (undefined === bodyMarginStr) {
	      bodyMarginStr = bodyMargin + 'px';
	    }
	
	    setBodyStyle('margin', chkCSS('margin', bodyMarginStr));
	  }
	
	  function stopInfiniteResizingOfIFrame() {
	    document.documentElement.style.height = '';
	    document.body.style.height = '';
	    log('HTML & body height set to "auto"');
	  }
	
	  function manageTriggerEvent(options) {
	    var listener = {
	      add: function(eventName) {
	        function handleEvent() {
	          sendSize(options.eventName, options.eventType);
	        }
	
	        eventHandlersByName[eventName] = handleEvent;
	
	        addEventListener(window, eventName, handleEvent, { passive: true });
	      },
	      remove: function(eventName) {
	        var handleEvent = eventHandlersByName[eventName];
	        delete eventHandlersByName[eventName];
	
	        removeEventListener(window, eventName, handleEvent);
	      }
	    };
	
	    if (options.eventNames && Array.prototype.map) {
	      options.eventName = options.eventNames[0];
	      options.eventNames.map(listener[options.method]);
	    } else {
	      listener[options.method](options.eventName);
	    }
	
	    log(
	      capitalizeFirstLetter(options.method) +
	        ' event listener: ' +
	        options.eventType
	    );
	  }
	
	  function manageEventListeners(method) {
	    manageTriggerEvent({
	      method: method,
	      eventType: 'Animation Start',
	      eventNames: ['animationstart', 'webkitAnimationStart']
	    });
	    manageTriggerEvent({
	      method: method,
	      eventType: 'Animation Iteration',
	      eventNames: ['animationiteration', 'webkitAnimationIteration']
	    });
	    manageTriggerEvent({
	      method: method,
	      eventType: 'Animation End',
	      eventNames: ['animationend', 'webkitAnimationEnd']
	    });
	    manageTriggerEvent({
	      method: method,
	      eventType: 'Input',
	      eventName: 'input'
	    });
	    manageTriggerEvent({
	      method: method,
	      eventType: 'Mouse Up',
	      eventName: 'mouseup'
	    });
	    manageTriggerEvent({
	      method: method,
	      eventType: 'Mouse Down',
	      eventName: 'mousedown'
	    });
	    manageTriggerEvent({
	      method: method,
	      eventType: 'Orientation Change',
	      eventName: 'orientationchange'
	    });
	    manageTriggerEvent({
	      method: method,
	      eventType: 'Print',
	      eventName: ['afterprint', 'beforeprint']
	    });
	    manageTriggerEvent({
	      method: method,
	      eventType: 'Ready State Change',
	      eventName: 'readystatechange'
	    });
	    manageTriggerEvent({
	      method: method,
	      eventType: 'Touch Start',
	      eventName: 'touchstart'
	    });
	    manageTriggerEvent({
	      method: method,
	      eventType: 'Touch End',
	      eventName: 'touchend'
	    });
	    manageTriggerEvent({
	      method: method,
	      eventType: 'Touch Cancel',
	      eventName: 'touchcancel'
	    });
	    manageTriggerEvent({
	      method: method,
	      eventType: 'Transition Start',
	      eventNames: [
	        'transitionstart',
	        'webkitTransitionStart',
	        'MSTransitionStart',
	        'oTransitionStart',
	        'otransitionstart'
	      ]
	    });
	    manageTriggerEvent({
	      method: method,
	      eventType: 'Transition Iteration',
	      eventNames: [
	        'transitioniteration',
	        'webkitTransitionIteration',
	        'MSTransitionIteration',
	        'oTransitionIteration',
	        'otransitioniteration'
	      ]
	    });
	    manageTriggerEvent({
	      method: method,
	      eventType: 'Transition End',
	      eventNames: [
	        'transitionend',
	        'webkitTransitionEnd',
	        'MSTransitionEnd',
	        'oTransitionEnd',
	        'otransitionend'
	      ]
	    });
	    if ('child' === resizeFrom) {
	      manageTriggerEvent({
	        method: method,
	        eventType: 'IFrame Resized',
	        eventName: 'resize'
	      });
	    }
	  }
	
	  function checkCalcMode(calcMode, calcModeDefault, modes, type) {
	    if (calcModeDefault !== calcMode) {
	      if (!(calcMode in modes)) {
	        warn(
	          calcMode + ' is not a valid option for ' + type + 'CalculationMethod.'
	        );
	        calcMode = calcModeDefault;
	      }
	      log(type + ' calculation method set to "' + calcMode + '"');
	    }
	
	    return calcMode;
	  }
	
	  function checkHeightMode() {
	    heightCalcMode = checkCalcMode(
	      heightCalcMode,
	      heightCalcModeDefault,
	      getHeight,
	      'height'
	    );
	  }
	
	  function checkWidthMode() {
	    widthCalcMode = checkCalcMode(
	      widthCalcMode,
	      widthCalcModeDefault,
	      getWidth,
	      'width'
	    );
	  }
	
	  function startEventListeners() {
	    if (true === autoResize) {
	      manageEventListeners('add');
	      setupMutationObserver();
	    } else {
	      log('Auto Resize disabled');
	    }
	  }
	
	  function stopMsgsToParent() {
	    log('Disable outgoing messages');
	    sendPermit = false;
	  }
	
	  function removeMsgListener() {
	    log('Remove event listener: Message');
	    removeEventListener(window, 'message', receiver);
	  }
	
	  function disconnectMutationObserver() {
	    if (null !== bodyObserver) {
	      /* istanbul ignore next */ // Not testable in PhantonJS
	      bodyObserver.disconnect();
	    }
	  }
	
	  function stopEventListeners() {
	    manageEventListeners('remove');
	    disconnectMutationObserver();
	    clearInterval(intervalTimer);
	  }
	
	  function teardown() {
	    stopMsgsToParent();
	    removeMsgListener();
	    if (true === autoResize) stopEventListeners();
	  }
	
	  function injectClearFixIntoBodyElement() {
	    var clearFix = document.createElement('div');
	    clearFix.style.clear = 'both';
	    clearFix.style.display = 'block'; //Guard against this having been globally redefined in CSS.
	    document.body.appendChild(clearFix);
	  }
	
	  function setupInPageLinks() {
	    function getPagePosition() {
	      return {
	        x:
	          window.pageXOffset !== undefined
	            ? window.pageXOffset
	            : document.documentElement.scrollLeft,
	        y:
	          window.pageYOffset !== undefined
	            ? window.pageYOffset
	            : document.documentElement.scrollTop
	      };
	    }
	
	    function getElementPosition(el) {
	      var elPosition = el.getBoundingClientRect(),
	        pagePosition = getPagePosition();
	
	      return {
	        x: parseInt(elPosition.left, 10) + parseInt(pagePosition.x, 10),
	        y: parseInt(elPosition.top, 10) + parseInt(pagePosition.y, 10)
	      };
	    }
	
	    function findTarget(location) {
	      function jumpToTarget(target) {
	        var jumpPosition = getElementPosition(target);
	
	        log(
	          'Moving to in page link (#' +
	            hash +
	            ') at x: ' +
	            jumpPosition.x +
	            ' y: ' +
	            jumpPosition.y
	        );
	        sendMsg(jumpPosition.y, jumpPosition.x, 'scrollToOffset'); // X&Y reversed at sendMsg uses height/width
	      }
	
	      var hash = location.split('#')[1] || location, //Remove # if present
	        hashData = decodeURIComponent(hash),
	        target =
	          document.getElementById(hashData) ||
	          document.getElementsByName(hashData)[0];
	
	      if (undefined !== target) {
	        jumpToTarget(target);
	      } else {
	        log(
	          'In page link (#' +
	            hash +
	            ') not found in iFrame, so sending to parent'
	        );
	        sendMsg(0, 0, 'inPageLink', '#' + hash);
	      }
	    }
	
	    function checkLocationHash() {
	      if ('' !== location.hash && '#' !== location.hash) {
	        findTarget(location.href);
	      }
	    }
	
	    function bindAnchors() {
	      function setupLink(el) {
	        function linkClicked(e) {
	          e.preventDefault();
	
	          /*jshint validthis:true */
	          findTarget(this.getAttribute('href'));
	        }
	
	        if ('#' !== el.getAttribute('href')) {
	          addEventListener(el, 'click', linkClicked);
	        }
	      }
	
	      Array.prototype.forEach.call(
	        document.querySelectorAll('a[href^="#"]'),
	        setupLink
	      );
	    }
	
	    function bindLocationHash() {
	      addEventListener(window, 'hashchange', checkLocationHash);
	    }
	
	    function initCheck() {
	      //check if page loaded with location hash after init resize
	      setTimeout(checkLocationHash, eventCancelTimer);
	    }
	
	    function enableInPageLinks() {
	      /* istanbul ignore else */ // Not testable in phantonJS
	      if (Array.prototype.forEach && document.querySelectorAll) {
	        log('Setting up location.hash handlers');
	        bindAnchors();
	        bindLocationHash();
	        initCheck();
	      } else {
	        warn(
	          'In page linking not fully supported in this browser! (See README.md for IE8 workaround)'
	        );
	      }
	    }
	
	    if (inPageLinks.enable) {
	      enableInPageLinks();
	    } else {
	      log('In page linking not enabled');
	    }
	
	    return {
	      findTarget: findTarget
	    };
	  }
	
	  function setupPublicMethods() {
	    log('Enable public methods');
	
	    win.parentIFrame = {
	      autoResize: function autoResizeF(resize) {
	        if (true === resize && false === autoResize) {
	          autoResize = true;
	          startEventListeners();
	          //sendSize('autoResize','Auto Resize enabled');
	        } else if (false === resize && true === autoResize) {
	          autoResize = false;
	          stopEventListeners();
	        }
	
	        return autoResize;
	      },
	
	      close: function closeF() {
	        sendMsg(0, 0, 'close');
	        teardown();
	      },
	
	      getId: function getIdF() {
	        return myID;
	      },
	
	      getPageInfo: function getPageInfoF(callback) {
	        if ('function' === typeof callback) {
	          pageInfoCallback = callback;
	          sendMsg(0, 0, 'pageInfo');
	        } else {
	          pageInfoCallback = function() {};
	          sendMsg(0, 0, 'pageInfoStop');
	        }
	      },
	
	      moveToAnchor: function moveToAnchorF(hash) {
	        inPageLinks.findTarget(hash);
	      },
	
	      reset: function resetF() {
	        resetIFrame('parentIFrame.reset');
	      },
	
	      scrollTo: function scrollToF(x, y) {
	        sendMsg(y, x, 'scrollTo'); // X&Y reversed at sendMsg uses height/width
	      },
	
	      scrollToOffset: function scrollToF(x, y) {
	        sendMsg(y, x, 'scrollToOffset'); // X&Y reversed at sendMsg uses height/width
	      },
	
	      sendMessage: function sendMessageF(msg, targetOrigin) {
	        sendMsg(0, 0, 'message', JSON.stringify(msg), targetOrigin);
	      },
	
	      setHeightCalculationMethod: function setHeightCalculationMethodF(
	        heightCalculationMethod
	      ) {
	        heightCalcMode = heightCalculationMethod;
	        checkHeightMode();
	      },
	
	      setWidthCalculationMethod: function setWidthCalculationMethodF(
	        widthCalculationMethod
	      ) {
	        widthCalcMode = widthCalculationMethod;
	        checkWidthMode();
	      },
	
	      setTargetOrigin: function setTargetOriginF(targetOrigin) {
	        log('Set targetOrigin: ' + targetOrigin);
	        targetOriginDefault = targetOrigin;
	      },
	
	      size: function sizeF(customHeight, customWidth) {
	        var valString =
	          '' +
	          (customHeight ? customHeight : '') +
	          (customWidth ? ',' + customWidth : '');
	        //lockTrigger();
	        sendSize(
	          'size',
	          'parentIFrame.size(' + valString + ')',
	          customHeight,
	          customWidth
	        );
	      }
	    };
	  }
	
	  function initInterval() {
	    if (0 !== interval) {
	      log('setInterval: ' + interval + 'ms');
	      intervalTimer = setInterval(function() {
	        sendSize('interval', 'setInterval: ' + interval);
	      }, Math.abs(interval));
	    }
	  } //Not testable in PhantomJS
	
	  /* istanbul ignore next */ function setupBodyMutationObserver() {
	    function addImageLoadListners(mutation) {
	      function addImageLoadListener(element) {
	        if (false === element.complete) {
	          log('Attach listeners to ' + element.src);
	          element.addEventListener('load', imageLoaded, false);
	          element.addEventListener('error', imageError, false);
	          elements.push(element);
	        }
	      }
	
	      if (mutation.type === 'attributes' && mutation.attributeName === 'src') {
	        addImageLoadListener(mutation.target);
	      } else if (mutation.type === 'childList') {
	        Array.prototype.forEach.call(
	          mutation.target.querySelectorAll('img'),
	          addImageLoadListener
	        );
	      }
	    }
	
	    function removeFromArray(element) {
	      elements.splice(elements.indexOf(element), 1);
	    }
	
	    function removeImageLoadListener(element) {
	      log('Remove listeners from ' + element.src);
	      element.removeEventListener('load', imageLoaded, false);
	      element.removeEventListener('error', imageError, false);
	      removeFromArray(element);
	    }
	
	    function imageEventTriggered(event, type, typeDesc) {
	      removeImageLoadListener(event.target);
	      sendSize(type, typeDesc + ': ' + event.target.src, undefined, undefined);
	    }
	
	    function imageLoaded(event) {
	      imageEventTriggered(event, 'imageLoad', 'Image loaded');
	    }
	
	    function imageError(event) {
	      imageEventTriggered(event, 'imageLoadFailed', 'Image load failed');
	    }
	
	    function mutationObserved(mutations) {
	      sendSize(
	        'mutationObserver',
	        'mutationObserver: ' + mutations[0].target + ' ' + mutations[0].type
	      );
	
	      //Deal with WebKit asyncing image loading when tags are injected into the page
	      mutations.forEach(addImageLoadListners);
	    }
	
	    function createMutationObserver() {
	      var target = document.querySelector('body'),
	        config = {
	          attributes: true,
	          attributeOldValue: false,
	          characterData: true,
	          characterDataOldValue: false,
	          childList: true,
	          subtree: true
	        };
	
	      observer = new MutationObserver(mutationObserved);
	
	      log('Create body MutationObserver');
	      observer.observe(target, config);
	
	      return observer;
	    }
	
	    var elements = [],
	      MutationObserver =
	        window.MutationObserver || window.WebKitMutationObserver,
	      observer = createMutationObserver();
	
	    return {
	      disconnect: function() {
	        if ('disconnect' in observer) {
	          log('Disconnect body MutationObserver');
	          observer.disconnect();
	          elements.forEach(removeImageLoadListener);
	        }
	      }
	    };
	  }
	
	  function setupMutationObserver() {
	    var forceIntervalTimer = 0 > interval; // Not testable in PhantomJS
	
	    /* istanbul ignore if */ if (
	      window.MutationObserver ||
	      window.WebKitMutationObserver
	    ) {
	      if (forceIntervalTimer) {
	        initInterval();
	      } else {
	        bodyObserver = setupBodyMutationObserver();
	      }
	    } else {
	      log('MutationObserver not supported in this browser!');
	      initInterval();
	    }
	  }
	
	  // document.documentElement.offsetHeight is not reliable, so
	  // we have to jump through hoops to get a better value.
	  function getComputedStyle(prop, el) {
	    /* istanbul ignore next */ //Not testable in PhantomJS
	    function convertUnitsToPxForIE8(value) {
	      var PIXEL = /^\d+(px)?$/i;
	
	      if (PIXEL.test(value)) {
	        return parseInt(value, base);
	      }
	
	      var style = el.style.left,
	        runtimeStyle = el.runtimeStyle.left;
	
	      el.runtimeStyle.left = el.currentStyle.left;
	      el.style.left = value || 0;
	      value = el.style.pixelLeft;
	      el.style.left = style;
	      el.runtimeStyle.left = runtimeStyle;
	
	      return value;
	    }
	
	    var retVal = 0;
	    el = el || document.body; // Not testable in phantonJS
	
	    /* istanbul ignore else */ if (
	      'defaultView' in document &&
	      'getComputedStyle' in document.defaultView
	    ) {
	      retVal = document.defaultView.getComputedStyle(el, null);
	      retVal = null !== retVal ? retVal[prop] : 0;
	    } else {
	      //IE8
	      retVal = convertUnitsToPxForIE8(el.currentStyle[prop]);
	    }
	
	    return parseInt(retVal, base);
	  }
	
	  function chkEventThottle(timer) {
	    if (timer > throttledTimer / 2) {
	      throttledTimer = 2 * timer;
	      log('Event throttle increased to ' + throttledTimer + 'ms');
	    }
	  }
	
	  //Idea from https://github.com/guardian/iframe-messenger
	  function getMaxElement(side, elements) {
	    var elementsLength = elements.length,
	      elVal = 0,
	      maxVal = 0,
	      Side = capitalizeFirstLetter(side),
	      timer = getNow();
	
	    for (var i = 0; i < elementsLength; i++) {
	      elVal =
	        elements[i].getBoundingClientRect()[side] +
	        getComputedStyle('margin' + Side, elements[i]);
	      if (elVal > maxVal) {
	        maxVal = elVal;
	      }
	    }
	
	    timer = getNow() - timer;
	
	    log('Parsed ' + elementsLength + ' HTML elements');
	    log('Element position calculated in ' + timer + 'ms');
	
	    chkEventThottle(timer);
	
	    return maxVal;
	  }
	
	  function getAllMeasurements(dimention) {
	    return [
	      dimention.bodyOffset(),
	      dimention.bodyScroll(),
	      dimention.documentElementOffset(),
	      dimention.documentElementScroll()
	    ];
	  }
	
	  function getTaggedElements(side, tag) {
	    function noTaggedElementsFound() {
	      warn('No tagged elements (' + tag + ') found on page');
	      return document.querySelectorAll('body *');
	    }
	
	    var elements = document.querySelectorAll('[' + tag + ']');
	
	    if (0 === elements.length) noTaggedElementsFound();
	
	    return getMaxElement(side, elements);
	  }
	
	  function getAllElements() {
	    return document.querySelectorAll('body *');
	  }
	
	  var getHeight = {
	      bodyOffset: function getBodyOffsetHeight() {
	        return (
	          document.body.offsetHeight +
	          getComputedStyle('marginTop') +
	          getComputedStyle('marginBottom')
	        );
	      },
	
	      offset: function() {
	        return getHeight.bodyOffset(); //Backwards compatability
	      },
	
	      bodyScroll: function getBodyScrollHeight() {
	        return document.body.scrollHeight;
	      },
	
	      custom: function getCustomWidth() {
	        return customCalcMethods.height();
	      },
	
	      documentElementOffset: function getDEOffsetHeight() {
	        return document.documentElement.offsetHeight;
	      },
	
	      documentElementScroll: function getDEScrollHeight() {
	        return document.documentElement.scrollHeight;
	      },
	
	      max: function getMaxHeight() {
	        return Math.max.apply(null, getAllMeasurements(getHeight));
	      },
	
	      min: function getMinHeight() {
	        return Math.min.apply(null, getAllMeasurements(getHeight));
	      },
	
	      grow: function growHeight() {
	        return getHeight.max(); //Run max without the forced downsizing
	      },
	
	      lowestElement: function getBestHeight() {
	        return Math.max(
	          getHeight.bodyOffset() || getHeight.documentElementOffset(),
	          getMaxElement('bottom', getAllElements())
	        );
	      },
	
	      taggedElement: function getTaggedElementsHeight() {
	        return getTaggedElements('bottom', 'data-iframe-height');
	      }
	    },
	    getWidth = {
	      bodyScroll: function getBodyScrollWidth() {
	        return document.body.scrollWidth;
	      },
	
	      bodyOffset: function getBodyOffsetWidth() {
	        return document.body.offsetWidth;
	      },
	
	      custom: function getCustomWidth() {
	        return customCalcMethods.width();
	      },
	
	      documentElementScroll: function getDEScrollWidth() {
	        return document.documentElement.scrollWidth;
	      },
	
	      documentElementOffset: function getDEOffsetWidth() {
	        return document.documentElement.offsetWidth;
	      },
	
	      scroll: function getMaxWidth() {
	        return Math.max(
	          getWidth.bodyScroll(),
	          getWidth.documentElementScroll()
	        );
	      },
	
	      max: function getMaxWidth() {
	        return Math.max.apply(null, getAllMeasurements(getWidth));
	      },
	
	      min: function getMinWidth() {
	        return Math.min.apply(null, getAllMeasurements(getWidth));
	      },
	
	      rightMostElement: function rightMostElement() {
	        return getMaxElement('right', getAllElements());
	      },
	
	      taggedElement: function getTaggedElementsWidth() {
	        return getTaggedElements('right', 'data-iframe-width');
	      }
	    };
	
	  function sizeIFrame(
	    triggerEvent,
	    triggerEventDesc,
	    customHeight,
	    customWidth
	  ) {
	    function resizeIFrame() {
	      height = currentHeight;
	      width = currentWidth;
	
	      sendMsg(height, width, triggerEvent);
	    }
	
	    function isSizeChangeDetected() {
	      function checkTolarance(a, b) {
	        var retVal = Math.abs(a - b) <= tolerance;
	        return !retVal;
	      }
	
	      currentHeight =
	        undefined !== customHeight ? customHeight : getHeight[heightCalcMode]();
	      currentWidth =
	        undefined !== customWidth ? customWidth : getWidth[widthCalcMode]();
	
	      return (
	        checkTolarance(height, currentHeight) ||
	        (calculateWidth && checkTolarance(width, currentWidth))
	      );
	    }
	
	    function isForceResizableEvent() {
	      return !(triggerEvent in { init: 1, interval: 1, size: 1 });
	    }
	
	    function isForceResizableCalcMode() {
	      return (
	        heightCalcMode in resetRequiredMethods ||
	        (calculateWidth && widthCalcMode in resetRequiredMethods)
	      );
	    }
	
	    function logIgnored() {
	      log('No change in size detected');
	    }
	
	    function checkDownSizing() {
	      if (isForceResizableEvent() && isForceResizableCalcMode()) {
	        resetIFrame(triggerEventDesc);
	      } else if (!(triggerEvent in { interval: 1 })) {
	        logIgnored();
	      }
	    }
	
	    var currentHeight, currentWidth;
	
	    if (isSizeChangeDetected() || 'init' === triggerEvent) {
	      lockTrigger();
	      resizeIFrame();
	    } else {
	      checkDownSizing();
	    }
	  }
	
	  var sizeIFrameThrottled = throttle(sizeIFrame);
	
	  function sendSize(triggerEvent, triggerEventDesc, customHeight, customWidth) {
	    function recordTrigger() {
	      if (!(triggerEvent in { reset: 1, resetPage: 1, init: 1 })) {
	        log('Trigger event: ' + triggerEventDesc);
	      }
	    }
	
	    function isDoubleFiredEvent() {
	      return triggerLocked && triggerEvent in doubleEventList;
	    }
	
	    if (!isDoubleFiredEvent()) {
	      recordTrigger();
	      if (triggerEvent === 'init') {
	        sizeIFrame(triggerEvent, triggerEventDesc, customHeight, customWidth);
	      } else {
	        sizeIFrameThrottled(
	          triggerEvent,
	          triggerEventDesc,
	          customHeight,
	          customWidth
	        );
	      }
	    } else {
	      log('Trigger event cancelled: ' + triggerEvent);
	    }
	  }
	
	  function lockTrigger() {
	    if (!triggerLocked) {
	      triggerLocked = true;
	      log('Trigger event lock on');
	    }
	    clearTimeout(triggerLockedTimer);
	    triggerLockedTimer = setTimeout(function() {
	      triggerLocked = false;
	      log('Trigger event lock off');
	      log('--');
	    }, eventCancelTimer);
	  }
	
	  function triggerReset(triggerEvent) {
	    height = getHeight[heightCalcMode]();
	    width = getWidth[widthCalcMode]();
	
	    sendMsg(height, width, triggerEvent);
	  }
	
	  function resetIFrame(triggerEventDesc) {
	    var hcm = heightCalcMode;
	    heightCalcMode = heightCalcModeDefault;
	
	    log('Reset trigger event: ' + triggerEventDesc);
	    lockTrigger();
	    triggerReset('reset');
	
	    heightCalcMode = hcm;
	  }
	
	  function sendMsg(height, width, triggerEvent, msg, targetOrigin) {
	    function setTargetOrigin() {
	      if (undefined === targetOrigin) {
	        targetOrigin = targetOriginDefault;
	      } else {
	        log('Message targetOrigin: ' + targetOrigin);
	      }
	    }
	
	    function sendToParent() {
	      var size = height + ':' + width,
	        message =
	          myID +
	          ':' +
	          size +
	          ':' +
	          triggerEvent +
	          (undefined !== msg ? ':' + msg : '');
	
	      log('Sending message to host page (' + message + ')');
	      target.postMessage(msgID + message, targetOrigin);
	    }
	
	    if (true === sendPermit) {
	      setTargetOrigin();
	      sendToParent();
	    }
	  }
	
	  function receiver(event) {
	    var processRequestFromParent = {
	      init: function initFromParent() {
	        initMsg = event.data;
	        target = event.source;
	
	        init();
	        firstRun = false;
	        setTimeout(function() {
	          initLock = false;
	        }, eventCancelTimer);
	      },
	
	      reset: function resetFromParent() {
	        if (!initLock) {
	          log('Page size reset by host page');
	          triggerReset('resetPage');
	        } else {
	          log('Page reset ignored by init');
	        }
	      },
	
	      resize: function resizeFromParent() {
	        sendSize('resizeParent', 'Parent window requested size check');
	      },
	
	      moveToAnchor: function moveToAnchorF() {
	        inPageLinks.findTarget(getData());
	      },
	      inPageLink: function inPageLinkF() {
	        this.moveToAnchor();
	      }, //Backward compatability
	
	      pageInfo: function pageInfoFromParent() {
	        var msgBody = getData();
	        log('PageInfoFromParent called from parent: ' + msgBody);
	        pageInfoCallback(JSON.parse(msgBody));
	        log(' --');
	      },
	
	      message: function messageFromParent() {
	        var msgBody = getData();
	
	        log('MessageCallback called from parent: ' + msgBody);
	        messageCallback(JSON.parse(msgBody));
	        log(' --');
	      }
	    };
	
	    function isMessageForUs() {
	      return msgID === ('' + event.data).substr(0, msgIdLen); //''+ Protects against non-string messages
	    }
	
	    function getMessageType() {
	      return event.data.split(']')[1].split(':')[0];
	    }
	
	    function getData() {
	      return event.data.substr(event.data.indexOf(':') + 1);
	    }
	
	    function isMiddleTier() {
	      return (
	        (!(typeof module !== 'undefined' && module.exports) &&
	          'iFrameResize' in window) ||
	        ('jQuery' in window && 'iFrameResize' in window.jQuery.prototype)
	      );
	    }
	
	    function isInitMsg() {
	      //Test if this message is from a child below us. This is an ugly test, however, updating
	      //the message format would break backwards compatibity.
	      return event.data.split(':')[2] in { true: 1, false: 1 };
	    }
	
	    function callFromParent() {
	      var messageType = getMessageType();
	
	      if (messageType in processRequestFromParent) {
	        processRequestFromParent[messageType]();
	      } else if (!isMiddleTier() && !isInitMsg()) {
	        warn('Unexpected message (' + event.data + ')');
	      }
	    }
	
	    function processMessage() {
	      if (false === firstRun) {
	        callFromParent();
	      } else if (isInitMsg()) {
	        processRequestFromParent.init();
	      } else {
	        log(
	          'Ignored message of type "' +
	            getMessageType() +
	            '". Received before initialization.'
	        );
	      }
	    }
	
	    if (isMessageForUs()) {
	      processMessage();
	    }
	  }
	
	  //Normally the parent kicks things off when it detects the iFrame has loaded.
	  //If this script is async-loaded, then tell parent page to retry init.
	  function chkLateLoaded() {
	    if ('loading' !== document.readyState) {
	      window.parent.postMessage('[iFrameResizerChild]Ready', '*');
	    }
	  }
	
	  addEventListener(window, 'message', receiver);
	  addEventListener(window, 'readystatechange', chkLateLoaded);
	  chkLateLoaded();
	
	  
	})();


/***/ }),
/* 19 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.default = floatLabelDirective;
	
	var _jquery = __webpack_require__(3);
	
	var _jquery2 = _interopRequireDefault(_jquery);
	
	var _autosize = __webpack_require__(14);
	
	var _autosize2 = _interopRequireDefault(_autosize);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * Applies the correct class names to the field.
	 *
	 * @param e - The event object
	 */
	function setState() {
	    var _this = this;
	
	    var e = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	
	    var field = (0, _jquery2.default)(this);
	
	    // Wrap within an instantaneous timeout so state changes can be detected on the next redraw. This fixes a
	    // problem with the "keydown" event in that the key value is added to the field after the event has been
	    // called. This means the value of the field returned will be the previous value. The timeout ensures that
	    // the input happens before the value is checked.
	    setTimeout(function () {
	
	        // Enhance the file input by outputting information about the selected file
	        if (field.is('input[type="file"]')) {
	            var div = field.siblings('div');
	            var fileName = '';
	
	            if (_this.files && _this.files.length > 1) {
	                fileName = _this.files.length + ' files selected';
	            } else {
	                fileName = _this.value.split('\\').pop();
	            }
	
	            div.html(fileName);
	        }
	
	        field.closest('[sw-float-label]')
	
	        // Set the field type as a class to the float label wrapper
	        .addClass('-type-' + field.prop('tagName').toLowerCase())
	
	        // Is the element in focus?
	        .toggleClass('is-focused', e.type == 'focus' || field.is(':focus'))
	
	        // Check if the fields value is an empty string. This works for select options that have an empty
	        // value. This can be exploited by creating an empty option, disabling it and setting it as the
	        // default.
	        .toggleClass('is-filled', !!field.val())
	
	        // Only apply if browser supports field validation
	        .toggleClass('is-invalid', field[0].validity && !field[0].validity.valid)
	
	        // Specifically for textarea's. This is useful so that the label can be hidden when the content is
	        // scrolled, so that the label and the fields text don't overlap and look ugly.
	        .toggleClass('is-scrolled', field.scrollTop() > 0);
	    });
	}
	
	/**
	 * Adds float label behaviour to marked fields.
	 *
	 * @param context
	 */
	function floatLabelDirective() {
	    var context = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : document.body;
	
	
	    (0, _jquery2.default)(context).find('[sw-float-label]').find('input, select, textarea').on('focus blur change keyup keydown scroll', setState).each(setState);
	}

/***/ }),
/* 20 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.default = validatorDirective;
	
	var _jquery = __webpack_require__(3);
	
	var _jquery2 = _interopRequireDefault(_jquery);
	
	var _request = __webpack_require__(21);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * The CDN directory of the Parsley library.
	 *
	 * @see http://parsleyjs.org/
	 * @type {string}
	 */
	var parsleyDir = 'https://cdnjs.cloudflare.com/ajax/libs/parsley.js/2.7.2/';
	
	function setFormEnabled($form, enabled) {
	    $form.find('input, select, textarea').prop('readonly', !enabled);
	    $form.find('button').prop('disabled', !enabled);
	}
	
	/**
	 * Enhances forms with live validation.
	 *
	 * @param context
	 */
	function validatorDirective() {
	    var context = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : document.body;
	
	    var $context = (0, _jquery2.default)(context);
	    var $forms = $context.find('form[sw-validator]');
	
	    // Only load Parsley if there are forms on the page
	    if ($forms.length > 0) {
	        (0, _request.dependency)(parsleyDir + 'parsley.min.js', function () {
	            return window.Parsley;
	        }).then(function () {
	            $forms.each(function () {
	                var $form = (0, _jquery2.default)(this);
	                var parsley = $form.parsley();
	
	                parsley.on('field:validated', function (_ref) {
	                    var $element = _ref.$element;
	
	                    // Make sure errors reported by the server get removed
	                    $element.siblings('.float-label_errors').remove();
	                });
	
	                parsley.on('form:submit', function (_ref2) {
	                    var $element = _ref2.$element;
	
	                    $element.addClass('is-posting');
	                    setFormEnabled($element, false);
	
	                    var target = $element.prop('target');
	                    var $iframe = target ? (0, _jquery2.default)('iframe[name="' + target + '"]') : (0, _jquery2.default)();
	
	                    $iframe.one('load', function (e) {
	                        $element.removeClass('is-posting');
	                        setFormEnabled($element, true);
	                    });
	                });
	            });
	        });
	    }
	}

/***/ }),
/* 21 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.dependency = dependency;
	
	var _jquery = __webpack_require__(3);
	
	var _jquery2 = _interopRequireDefault(_jquery);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * Loads an external Javascript file and executes it.
	 *
	 * @param url - The URL to the Javascript file
	 * @param check - An optional function to return a boolean for manually checking if the script has correctly executed.
	 *   This ensures that the callback actually happens after the script has been executed. For example, if loading jQuery
	 *   this function could check whether the jQuery property exists on the window object.
	 * @return Promise
	 */
	var loadedDependencies = null;
	function dependency(url) {
	    var check = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : function () {
	        return true;
	    };
	    var timeout = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 10000;
	
	
	    if (!loadedDependencies) {
	        loadedDependencies = {};
	
	        // Add existing Javascript files as dependencies
	        // TODO Handle `defer` and `async`
	        (0, _jquery2.default)('script[src]').each(function () {
	            var src = (0, _jquery2.default)(this).prop('src');
	            loadedDependencies[src] = true;
	        });
	    }
	
	    return new Promise(function (resolve, reject) {
	
	        var startTime = Date.now();
	        function poll() {
	            if (check()) {
	                resolve();
	            } else if (Date.now() - startTime > timeout) {
	                reject();
	            } else {
	                setTimeout(poll, 50);
	            }
	        }
	
	        if (!loadedDependencies[url]) {
	            loadedDependencies[url] = true;
	            _jquery2.default.getScript(url).done(poll).fail(reject);
	        } else {
	            poll();
	        }
	    });
	}

/***/ }),
/* 22 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.default = lightboxDirective;
	
	var _jquery = __webpack_require__(3);
	
	var _jquery2 = _interopRequireDefault(_jquery);
	
	var _request = __webpack_require__(21);
	
	var _drawing = __webpack_require__(10);
	
	var _parse = __webpack_require__(6);
	
	var _data = __webpack_require__(23);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * The CDN directory of the PhotoSwipe library.
	 *
	 * @see http://photoswipe.com
	 * @type {string}
	 */
	var photoswipeDir = 'https://cdnjs.cloudflare.com/ajax/libs/photoswipe/4.1.2/';
	
	/**
	 * The reusable template for PhotoSwipe.
	 *
	 * @see http://photoswipe.com/documentation/getting-started.html
	 */
	var template = '\n    <div id="lightbox" class="pswp lightbox" tabindex="-1" role="dialog" aria-hidden="true">\n        <div class="pswp__bg"></div>\n        <div class="pswp__scroll-wrap">\n            <div class="pswp__container">\n                <div class="pswp__item lightbox_item"></div>\n                <div class="pswp__item lightbox_item"></div>\n                <div class="pswp__item lightbox_item"></div>\n            </div>\n            <div class="pswp__ui pswp__ui--hidden">\n                <div class="pswp__top-bar">\n                    <div class="pswp__counter"></div>\n                    <button class="pswp__button pswp__button--close" title="Close (Esc)"></button>\n                    <button class="pswp__button pswp__button--share" title="Share"></button>\n                    <button class="pswp__button pswp__button--fs" title="Toggle fullscreen"></button>\n                    <button class="pswp__button pswp__button--zoom" title="Zoom in/out"></button>\n                    <div class="pswp__preloader">\n                        <div class="pswp__preloader__icn">\n                          <div class="pswp__preloader__cut">\n                            <div class="pswp__preloader__donut"></div>\n                          </div>\n                        </div>\n                    </div>\n                </div>\n                <div class="pswp__share-modal pswp__share-modal--hidden pswp__single-tap">\n                    <div class="pswp__share-tooltip"></div>\n                </div>\n                <button class="pswp__button pswp__button--arrow--left" title="Previous (arrow left)"></button>\n                <button class="pswp__button pswp__button--arrow--right" title="Next (arrow right)"></button>\n                <div class="pswp__caption">\n                    <div class="pswp__caption__center"></div>\n                </div>\n            </div>\n        </div>\n    </div>\n';
	
	/**
	 *
	 * @param element
	 * @returns {{}}
	 */
	function getConfigFromElement(element) {
	    // TODO
	    return {};
	}
	
	var initialised = false;
	var pswpElement = null;
	
	/**
	 * Initializes a PhotoSwipe gallery.
	 *
	 * @see http://idangero.us/swiper
	 * @param context
	 */
	function lightboxDirective() {
	    var context = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : document.body;
	
	    var $context = (0, _jquery2.default)(context);
	    var $lightboxes = $context.find('[sw-lightbox]');
	
	    if ($lightboxes.length > 0) {
	
	        if (!initialised) {
	            initialised = true;
	
	            (0, _jquery2.default)('head').append('\n                <link rel="stylesheet" href="' + photoswipeDir + 'photoswipe.min.css">\n                <link rel="stylesheet" href="' + photoswipeDir + 'default-skin/default-skin.min.css">\n            ');
	
	            (0, _jquery2.default)('body').append(template);
	
	            pswpElement = (0, _jquery2.default)('#lightbox')[0];
	        }
	
	        (0, _request.dependency)(photoswipeDir + 'photoswipe.min.js');
	        (0, _request.dependency)(photoswipeDir + 'photoswipe-ui-default.min.js', function () {
	            return window.PhotoSwipe && window.PhotoSwipeUI_Default;
	        }).then(function () {
	            var groups = {};
	
	            $lightboxes.each(function () {
	                var $element = (0, _jquery2.default)(this);
	                var json = $element.attr('sw-lightbox');
	                var settings = (0, _parse.directiveSettings)(json, {
	                    group: null,
	                    thumbnailUrl: '',
	                    html: '',
	                    url: '',
	                    width: 1280,
	                    height: 720,
	                    title: null
	                }, 'url');
	
	                settings.group = settings.group || (0, _data.uniqueId)();
	
	                if (!(settings.group in groups)) {
	                    groups[settings.group] = {
	                        elements: [],
	                        items: []
	                    };
	                }
	
	                var group = groups[settings.group];
	                var item = {
	                    msrc: settings.thumbnailUrl,
	                    w: settings.width | 0,
	                    h: settings.height | 0,
	                    title: settings.title
	                };
	
	                if (settings.html) {
	                    item.html = settings.html;
	                } else {
	                    item.src = settings.url;
	                }
	
	                group.elements.push(this);
	                group.items.push(item);
	
	                $element.on('click', function (e) {
	                    e.preventDefault();
	
	                    var options = {
	                        history: false,
	                        index: group.elements.indexOf(this),
	                        getThumbBoundsFn: function getThumbBoundsFn(index) {
	                            var $currentElement = (0, _jquery2.default)(group.elements[index]);
	                            var $thumb = $currentElement.is('[sw-lightbox-thumb]') ? $currentElement : $currentElement.find('[sw-lightbox-thumb]');
	                            var offset = $thumb.offset();
	                            var width = $thumb.width();
	                            var height = $thumb.height();
	
	                            // If the thumbnail has been letterboxed, this will get the correct width
	                            var trueWidth = Math.min(width, height / settings.height * settings.width);
	
	                            return offset ? {
	                                x: offset.left + (width - trueWidth) / 2,
	                                y: offset.top,
	                                w: trueWidth
	                            } : null;
	                        }
	                    };
	
	                    var gallery = new PhotoSwipe(pswpElement, PhotoSwipeUI_Default, group.items, options);
	                    gallery.init();
	                });
	            });
	        });
	    }
	}

/***/ }),
/* 23 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.uniqueId = uniqueId;
	/**
	 * Generates a unique ID.
	 *
	 * @returns String
	 */
	var existingUniqueIds = {};
	function uniqueId() {
	    var range = Math.pow(10, 9);
	    var id = null;
	    while (!id || existingUniqueIds[id]) {
	        id = 'id' + (Math.random() * range | 0).toString(36);
	    }
	    existingUniqueIds[id] = true;
	    return id;
	}

/***/ }),
/* 24 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.default = playOnHoverDirective;
	
	var _jquery = __webpack_require__(3);
	
	var _jquery2 = _interopRequireDefault(_jquery);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function playOnHoverDirective() {
	    var context = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : document.body;
	
	    var $element = (0, _jquery2.default)(context).find('[sw-play-on-hover]');
	
	    $element.each(function () {
	        var $this = (0, _jquery2.default)(this);
	        var $videos = $this.find('video');
	
	        $this.on('mouseenter', function () {
	            $videos.each(function () {
	                if (!this.ended || this.loop) {
	                    this.play();
	                }
	            });
	        }).on('mouseleave', function () {
	            $videos.each(function () {
	                this.pause();
	            });
	        });
	    });
	}

/***/ }),
/* 25 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.default = swiperDirective;
	
	var _jquery = __webpack_require__(3);
	
	var _jquery2 = _interopRequireDefault(_jquery);
	
	var _request = __webpack_require__(21);
	
	var _drawing = __webpack_require__(10);
	
	var _parse = __webpack_require__(6);
	
	var _window = __webpack_require__(26);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * The CDN directory of the Swiper library.
	 *
	 * @see http://idangero.us/swiper
	 * @type {string}
	 */
	var swiperDir = 'https://cdnjs.cloudflare.com/ajax/libs/Swiper/3.4.2/';
	
	var addedCss = false;
	
	/**
	 * Initializes a Swiper carousel.
	 *
	 * @see http://idangero.us/swiper
	 * @param context
	 */
	function swiperDirective() {
	    var context = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : document.body;
	
	    var $context = (0, _jquery2.default)(context);
	    var $swipers = $context.find('[sw-swiper]');
	
	    if ($swipers.length > 0) {
	
	        if (!addedCss) {
	            addedCss = true;
	            (0, _jquery2.default)('head').append('<link rel="stylesheet" href="' + swiperDir + 'css/swiper.min.css">');
	        }
	
	        (0, _request.dependency)(swiperDir + 'js/swiper.min.js', function () {
	            return window.Swiper;
	        }).then(function () {
	            $swipers.each(function () {
	                var $element = (0, _jquery2.default)(this);
	                var $slides = $element.find('.swiper-slide');
	                var json = $element.attr('sw-swiper');
	                var settings = (0, _parse.directiveSettings)(json, {
	                    loop: true,
	                    preloadImages: false,
	                    lazyLoading: true,
	                    lazyLoadingInPrevNext: true,
	                    paginationElement: 'button',
	                    paginationClickable: true,
	                    runCallbacksOnInit: true
	                });
	
	                var swiper = new Swiper(this, settings);
	
	                if ($element.hasClass('carousel_thumbs')) {
	                    var swiperId = $element.attr('id').slice(0, -7);
	                    var parentSwiper = (0, _jquery2.default)('#' + swiperId)[0].swiper;
	                    swiper.params.control = parentSwiper;
	                    parentSwiper.params.control = swiper;
	                }
	
	                (0, _drawing.frame)(function () {
	                    return $element.addClass('swiper-ready');
	                });
	
	                (0, _window.onResize)(function () {
	                    if ($element.hasClass('slideshow')) {
	                        $element.find('.slideshow_slide_content').each(function () {
	                            var $slide = (0, _jquery2.default)(this);
	                            var slideHeight = $slide.children('.slideshow_slide_content_v').outerHeight();
	                            var slidePadding = parseInt($slide.css('padding-top')) + parseInt($slide.css('padding-bottom'));
	                            var slideshowHeight = $element.outerHeight();
	
	                            if (slideHeight + slidePadding > slideshowHeight && !$slide.hasClass('+transparent')) {
	                                $slide.addClass('+transparent');
	                            } else if (slideHeight + slidePadding <= slideshowHeight && $slide.hasClass('+transparent')) {
	                                $slide.removeClass('+transparent');
	                            }
	                        });
	                    }
	                });
	            });
	        });
	    }
	}

/***/ }),
/* 26 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.getProperties = getProperties;
	exports.getWidth = getWidth;
	exports.getHeight = getHeight;
	exports.getScrollTop = getScrollTop;
	exports.getScrollLeft = getScrollLeft;
	exports.getScrollWidth = getScrollWidth;
	exports.getScrollHeight = getScrollHeight;
	exports.onResize = onResize;
	exports.onScroll = onScroll;
	
	var _jquery = __webpack_require__(3);
	
	var _jquery2 = _interopRequireDefault(_jquery);
	
	var _drawing = __webpack_require__(10);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var $window = (0, _jquery2.default)(window);
	var properties = {};
	
	function updateDimensions() {
	  properties.width = $window.width();
	  properties.height = $window.height();
	}
	
	function updateScroll() {
	  properties.scrollTop = document.documentElement.scrollTop || document.body.scrollTop;
	  properties.scrollLeft = document.documentElement.scrollLeft || document.body.scrollLeft;
	  properties.scrollWidth = document.documentElement.scrollWidth || document.body.scrollWidth;
	  properties.scrollHeight = document.documentElement.scrollHeight || document.body.scrollHeight;
	}
	
	updateDimensions();
	updateScroll();
	
	$window.on('load resize', function () {
	  updateDimensions();updateScroll();
	});
	$window.on('scroll', function () {
	  updateScroll();
	});
	
	/**
	 * Returns all the above properties of the window object.
	 *
	 * @returns Object
	 */
	function getProperties() {
	  return Object.assign({}, properties);
	}
	
	/**
	 * Returns the width of the window in pixels.
	 *
	 * @returns Number
	 */
	function getWidth() {
	  return properties.width;
	}
	
	/**
	 * Returns the height of the window in pixels.
	 *
	 * @returns Number
	 */
	function getHeight() {
	  return properties.height;
	}
	
	/**
	 * Returns the top scroll value of the window in pixels.
	 *
	 * @returns Number
	 */
	function getScrollTop() {
	  return properties.scrollTop;
	}
	
	/**
	 * Returns the left scroll value of the window in pixels.
	 *
	 * @returns Number
	 */
	function getScrollLeft() {
	  return properties.scrollLeft;
	}
	
	/**
	 * Returns the scrollable width of the window in pixels.
	 *
	 * @returns Number
	 */
	function getScrollWidth() {
	  return properties.scrollWidth;
	}
	
	/**
	 * Returns the scrollable height of the window in pixels.
	 *
	 * @returns Number
	 */
	function getScrollHeight() {
	  return properties.scrollHeight;
	}
	
	/**
	 * Binds a callback to resize events in a performant way.
	 * Returns a function that, when called, unbinds the events.
	 *
	 * @param callback
	 * @returns {Function}
	 */
	function onResize(callback) {
	  var currentFrame = void 0;
	  function debounce(e) {
	    (0, _drawing.unframe)(currentFrame);
	    currentFrame = (0, _drawing.frame)(function () {
	      return callback(e);
	    });
	  }
	
	  $window.on('load resize', debounce);
	
	  callback();
	
	  return function () {
	    return $window.off('load resize', debounce);
	  };
	}
	
	/**
	 * Binds a callback to scrolling events in a performant way.
	 * Returns a function that, when called, unbinds the events.
	 *
	 * @param callback
	 * @returns {Function}
	 */
	function onScroll(callback) {
	  var currentFrame = void 0;
	  function debounce(e) {
	    (0, _drawing.unframe)(currentFrame);
	    currentFrame = (0, _drawing.frame)(function () {
	      return callback(e);
	    });
	  }
	
	  $window.on('load resize scroll', debounce);
	
	  callback();
	
	  return function () {
	    return $window.off('load resize scroll', debounce);
	  };
	}

/***/ }),
/* 27 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.default = fadeDirective;
	
	var _jquery = __webpack_require__(3);
	
	var _jquery2 = _interopRequireDefault(_jquery);
	
	var _parse = __webpack_require__(6);
	
	var _window = __webpack_require__(26);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * Fades an element out or in, the closer or farther it moves to or from the top of the window.
	 * Start fade-out once an element reaches 25% of the window height: <div sw-fade="0.25"></div>
	 * Start fade-out at 75% of the window height, and finish at 25%, based on the top position of the element:
	 * <div sw-fade='{"scroll": 0.5, "position": "top", "offset": 0.25}'></div>
	 *
	 * @param context
	 */
	function fadeDirective() {
	    var context = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : document.body;
	
	    var $context = (0, _jquery2.default)(context);
	
	    $context.find('[sw-fade]').each(function () {
	        var $element = (0, _jquery2.default)(this);
	        var json = $element.attr('sw-fade');
	        var settings = (0, _parse.directiveSettings)(json, {
	            scroll: 0.25,
	            position: 'middle',
	            offset: 0
	        }, 'scroll');
	
	        (0, _window.onScroll)(function () {
	            var elementOffset = $element.offset().top - (0, _window.getHeight)() * settings.offset;
	            var elementHeight = $element.outerHeight();
	            var elementPosition = void 0;
	            switch (settings.position) {
	                case 'top':
	                    elementPosition = 0;break;
	                case 'bottom':
	                    elementPosition = elementHeight;break;
	                default:
	                    elementPosition = elementHeight / 2;break;
	            }
	            var contentPos = elementOffset + elementPosition - (0, _window.getScrollTop)();
	            var fadeHeight = (0, _window.getHeight)() * settings.scroll;
	            var opacity = contentPos / fadeHeight;
	            if (opacity < 0) {
	                opacity = 0;
	            } else if (opacity > 1) {
	                opacity = 1;
	            }
	            if (parseFloat($element.css('opacity')) !== opacity) {
	                $element.css('opacity', opacity);
	            }
	        });
	    });
	}

/***/ }),
/* 28 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = lazyLoadDirective;
	
	var _jquery = __webpack_require__(3);
	
	var _jquery2 = _interopRequireDefault(_jquery);
	
	var _blazy = __webpack_require__(29);
	
	var _blazy2 = _interopRequireDefault(_blazy);
	
	var _data = __webpack_require__(23);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * Lazily loads images, backgrounds, videos and iframes.
	 *
	 * @see http://dinbror.dk/blog/blazy/
	 * @param context
	 */
	function lazyLoadDirective() {
	  var context = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : document.body;
	
	  var container = 'window';
	
	  /*
	   * Problem:
	   *   Blazy library only supports a string selector for the container element.
	   *   This means that the `context` argument above cannot be passed directly as a DOM element to the Blazy
	   *   initialisation function.
	   *
	   * Solution:
	   *   Generate a unique attribute for the element, add it to the element, then use a selector targeting that
	   *   attribute.
	   */
	  if (context !== document.body) {
	    var uniqueAttr = 'data-' + (0, _data.uniqueId)();
	    container = '[' + uniqueAttr + ']';
	
	    (0, _jquery2.default)(context).attr(uniqueAttr, true);
	  }
	
	  var blazy = new _blazy2.default({
	    container: container,
	    selector: '[sw-lazy-load]',
	    src: 'sw-lazy-load',
	    successClass: 'is-ready',
	    errorClass: 'is-broken',
	    success: function success() {
	      return blazy.revalidate();
	    },
	    loadInvisible: true
	  });
	}

/***/ }),
/* 29 */
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_RESULT__;/*!
	  hey, [be]Lazy.js - v1.8.2 - 2016.10.25
	  A fast, small and dependency free lazy load script (https://github.com/dinbror/blazy)
	  (c) Bjoern Klinggaard - @bklinggaard - http://dinbror.dk/blazy
	*/
	;
	(function(root, blazy) {
	    if (true) {
	        // AMD. Register bLazy as an anonymous module
	        !(__WEBPACK_AMD_DEFINE_FACTORY__ = (blazy), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.call(exports, __webpack_require__, exports, module)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	    } else if (typeof exports === 'object') {
	        // Node. Does not work with strict CommonJS, but
	        // only CommonJS-like environments that support module.exports,
	        // like Node.
	        module.exports = blazy();
	    } else {
	        // Browser globals. Register bLazy on window
	        root.Blazy = blazy();
	    }
	})(this, function() {
	    'use strict';
	
	    //private vars
	    var _source, _viewport, _isRetina, _supportClosest, _attrSrc = 'src', _attrSrcset = 'srcset';
	
	    // constructor
	    return function Blazy(options) {
	        //IE7- fallback for missing querySelectorAll support
	        if (!document.querySelectorAll) {
	            var s = document.createStyleSheet();
	            document.querySelectorAll = function(r, c, i, j, a) {
	                a = document.all, c = [], r = r.replace(/\[for\b/gi, '[htmlFor').split(',');
	                for (i = r.length; i--;) {
	                    s.addRule(r[i], 'k:v');
	                    for (j = a.length; j--;) a[j].currentStyle.k && c.push(a[j]);
	                    s.removeRule(0);
	                }
	                return c;
	            };
	        }
	
	        //options and helper vars
	        var scope = this;
	        var util = scope._util = {};
	        util.elements = [];
	        util.destroyed = true;
	        scope.options = options || {};
	        scope.options.error = scope.options.error || false;
	        scope.options.offset = scope.options.offset || 100;
	        scope.options.root = scope.options.root || document;
	        scope.options.success = scope.options.success || false;
	        scope.options.selector = scope.options.selector || '.b-lazy';
	        scope.options.separator = scope.options.separator || '|';
	        scope.options.containerClass = scope.options.container;
	        scope.options.container = scope.options.containerClass ? document.querySelectorAll(scope.options.containerClass) : false;
	        scope.options.errorClass = scope.options.errorClass || 'b-error';
	        scope.options.breakpoints = scope.options.breakpoints || false;
	        scope.options.loadInvisible = scope.options.loadInvisible || false;
	        scope.options.successClass = scope.options.successClass || 'b-loaded';
	        scope.options.validateDelay = scope.options.validateDelay || 25;
	        scope.options.saveViewportOffsetDelay = scope.options.saveViewportOffsetDelay || 50;
	        scope.options.srcset = scope.options.srcset || 'data-srcset';
	        scope.options.src = _source = scope.options.src || 'data-src';
	        _supportClosest = Element.prototype.closest;
	        _isRetina = window.devicePixelRatio > 1;
	        _viewport = {};
	        _viewport.top = 0 - scope.options.offset;
	        _viewport.left = 0 - scope.options.offset;
	
	
	        /* public functions
	         ************************************/
	        scope.revalidate = function() {
	            initialize(scope);
	        };
	        scope.load = function(elements, force) {
	            var opt = this.options;
	            if (elements && elements.length === undefined) {
	                loadElement(elements, force, opt);
	            } else {
	                each(elements, function(element) {
	                    loadElement(element, force, opt);
	                });
	            }
	        };
	        scope.destroy = function() {            
	            var util = scope._util;
	            if (scope.options.container) {
	                each(scope.options.container, function(object) {
	                    unbindEvent(object, 'scroll', util.validateT);
	                });
	            }
	            unbindEvent(window, 'scroll', util.validateT);
	            unbindEvent(window, 'resize', util.validateT);
	            unbindEvent(window, 'resize', util.saveViewportOffsetT);
	            util.count = 0;
	            util.elements.length = 0;
	            util.destroyed = true;
	        };
	
	        //throttle, ensures that we don't call the functions too often
	        util.validateT = throttle(function() {
	            validate(scope);
	        }, scope.options.validateDelay, scope);
	        util.saveViewportOffsetT = throttle(function() {
	            saveViewportOffset(scope.options.offset);
	        }, scope.options.saveViewportOffsetDelay, scope);
	        saveViewportOffset(scope.options.offset);
	
	        //handle multi-served image src (obsolete)
	        each(scope.options.breakpoints, function(object) {
	            if (object.width >= window.screen.width) {
	                _source = object.src;
	                return false;
	            }
	        });
	
	        // start lazy load
	        setTimeout(function() {
	            initialize(scope);
	        }); // "dom ready" fix
	
	    };
	
	
	    /* Private helper functions
	     ************************************/
	    function initialize(self) {
	        var util = self._util;
	        // First we create an array of elements to lazy load
	        util.elements = toArray(self.options);
	        util.count = util.elements.length;
	        // Then we bind resize and scroll events if not already binded
	        if (util.destroyed) {
	            util.destroyed = false;
	            if (self.options.container) {
	                each(self.options.container, function(object) {
	                    bindEvent(object, 'scroll', util.validateT);
	                });
	            }
	            bindEvent(window, 'resize', util.saveViewportOffsetT);
	            bindEvent(window, 'resize', util.validateT);
	            bindEvent(window, 'scroll', util.validateT);
	        }
	        // And finally, we start to lazy load.
	        validate(self);
	    }
	
	    function validate(self) {
	        var util = self._util;
	        for (var i = 0; i < util.count; i++) {
	            var element = util.elements[i];
	            if (elementInView(element, self.options) || hasClass(element, self.options.successClass)) {
	                self.load(element);
	                util.elements.splice(i, 1);
	                util.count--;
	                i--;
	            }
	        }
	        if (util.count === 0) {
	            self.destroy();
	        }
	    }
	
	    function elementInView(ele, options) {
	        var rect = ele.getBoundingClientRect();
	
	        if(options.container && _supportClosest){
	            // Is element inside a container?
	            var elementContainer = ele.closest(options.containerClass);
	            if(elementContainer){
	                var containerRect = elementContainer.getBoundingClientRect();
	                // Is container in view?
	                if(inView(containerRect, _viewport)){
	                    var top = containerRect.top - options.offset;
	                    var right = containerRect.right + options.offset;
	                    var bottom = containerRect.bottom + options.offset;
	                    var left = containerRect.left - options.offset;
	                    var containerRectWithOffset = {
	                        top: top > _viewport.top ? top : _viewport.top,
	                        right: right < _viewport.right ? right : _viewport.right,
	                        bottom: bottom < _viewport.bottom ? bottom : _viewport.bottom,
	                        left: left > _viewport.left ? left : _viewport.left
	                    };
	                    // Is element in view of container?
	                    return inView(rect, containerRectWithOffset);
	                } else {
	                    return false;
	                }
	            }
	        }      
	        return inView(rect, _viewport);
	    }
	
	    function inView(rect, viewport){
	        // Intersection
	        return rect.right >= viewport.left &&
	               rect.bottom >= viewport.top && 
	               rect.left <= viewport.right && 
	               rect.top <= viewport.bottom;
	    }
	
	    function loadElement(ele, force, options) {
	        // if element is visible, not loaded or forced
	        if (!hasClass(ele, options.successClass) && (force || options.loadInvisible || (ele.offsetWidth > 0 && ele.offsetHeight > 0))) {
	            var dataSrc = getAttr(ele, _source) || getAttr(ele, options.src); // fallback to default 'data-src'
	            if (dataSrc) {
	                var dataSrcSplitted = dataSrc.split(options.separator);
	                var src = dataSrcSplitted[_isRetina && dataSrcSplitted.length > 1 ? 1 : 0];
	                var srcset = getAttr(ele, options.srcset);
	                var isImage = equal(ele, 'img');
	                var parent = ele.parentNode;
	                var isPicture = parent && equal(parent, 'picture');
	                // Image or background image
	                if (isImage || ele.src === undefined) {
	                    var img = new Image();
	                    // using EventListener instead of onerror and onload
	                    // due to bug introduced in chrome v50 
	                    // (https://productforums.google.com/forum/#!topic/chrome/p51Lk7vnP2o)
	                    var onErrorHandler = function() {
	                        if (options.error) options.error(ele, "invalid");
	                        addClass(ele, options.errorClass);
	                        unbindEvent(img, 'error', onErrorHandler);
	                        unbindEvent(img, 'load', onLoadHandler);
	                    };
	                    var onLoadHandler = function() {
	                        // Is element an image
	                        if (isImage) {
	                            if(!isPicture) {
	                                handleSources(ele, src, srcset);
	                            }
	                        // or background-image
	                        } else {
	                            ele.style.backgroundImage = 'url("' + src + '")';
	                        }
	                        itemLoaded(ele, options);
	                        unbindEvent(img, 'load', onLoadHandler);
	                        unbindEvent(img, 'error', onErrorHandler);
	                    };
	                    
	                    // Picture element
	                    if (isPicture) {
	                        img = ele; // Image tag inside picture element wont get preloaded
	                        each(parent.getElementsByTagName('source'), function(source) {
	                            handleSource(source, _attrSrcset, options.srcset);
	                        });
	                    }
	                    bindEvent(img, 'error', onErrorHandler);
	                    bindEvent(img, 'load', onLoadHandler);
	                    handleSources(img, src, srcset); // Preload
	
	                } else { // An item with src like iframe, unity games, simpel video etc
	                    ele.src = src;
	                    itemLoaded(ele, options);
	                }
	            } else {
	                // video with child source
	                if (equal(ele, 'video')) {
	                    each(ele.getElementsByTagName('source'), function(source) {
	                        handleSource(source, _attrSrc, options.src);
	                    });
	                    ele.load();
	                    itemLoaded(ele, options);
	                } else {
	                    if (options.error) options.error(ele, "missing");
	                    addClass(ele, options.errorClass);
	                }
	            }
	        }
	    }
	
	    function itemLoaded(ele, options) {
	        addClass(ele, options.successClass);
	        if (options.success) options.success(ele);
	        // cleanup markup, remove data source attributes
	        removeAttr(ele, options.src);
	        removeAttr(ele, options.srcset);
	        each(options.breakpoints, function(object) {
	            removeAttr(ele, object.src);
	        });
	    }
	
	    function handleSource(ele, attr, dataAttr) {
	        var dataSrc = getAttr(ele, dataAttr);
	        if (dataSrc) {
	            setAttr(ele, attr, dataSrc);
	            removeAttr(ele, dataAttr);
	        }
	    }
	
	    function handleSources(ele, src, srcset){
	        if(srcset) {
	            setAttr(ele, _attrSrcset, srcset); //srcset
	        }
	        ele.src = src; //src 
	    }
	
	    function setAttr(ele, attr, value){
	        ele.setAttribute(attr, value);
	    }
	
	    function getAttr(ele, attr) {
	        return ele.getAttribute(attr);
	    }
	
	    function removeAttr(ele, attr){
	        ele.removeAttribute(attr); 
	    }
	
	    function equal(ele, str) {
	        return ele.nodeName.toLowerCase() === str;
	    }
	
	    function hasClass(ele, className) {
	        return (' ' + ele.className + ' ').indexOf(' ' + className + ' ') !== -1;
	    }
	
	    function addClass(ele, className) {
	        if (!hasClass(ele, className)) {
	            ele.className += ' ' + className;
	        }
	    }
	
	    function toArray(options) {
	        var array = [];
	        var nodelist = (options.root).querySelectorAll(options.selector);
	        for (var i = nodelist.length; i--; array.unshift(nodelist[i])) {}
	        return array;
	    }
	
	    function saveViewportOffset(offset) {
	        _viewport.bottom = (window.innerHeight || document.documentElement.clientHeight) + offset;
	        _viewport.right = (window.innerWidth || document.documentElement.clientWidth) + offset;
	    }
	
	    function bindEvent(ele, type, fn) {
	        if (ele.attachEvent) {
	            ele.attachEvent && ele.attachEvent('on' + type, fn);
	        } else {
	            ele.addEventListener(type, fn, { capture: false, passive: true });
	        }
	    }
	
	    function unbindEvent(ele, type, fn) {
	        if (ele.detachEvent) {
	            ele.detachEvent && ele.detachEvent('on' + type, fn);
	        } else {
	            ele.removeEventListener(type, fn, { capture: false, passive: true });
	        }
	    }
	
	    function each(object, fn) {
	        if (object && fn) {
	            var l = object.length;
	            for (var i = 0; i < l && fn(object[i], i) !== false; i++) {}
	        }
	    }
	
	    function throttle(fn, minDelay, scope) {
	        var lastCall = 0;
	        return function() {
	            var now = +new Date();
	            if (now - lastCall < minDelay) {
	                return;
	            }
	            lastCall = now;
	            fn.apply(scope, arguments);
	        };
	    }
	});


/***/ }),
/* 30 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.default = parallaxDirective;
	
	var _jquery = __webpack_require__(3);
	
	var _jquery2 = _interopRequireDefault(_jquery);
	
	var _drawing = __webpack_require__(10);
	
	var _window = __webpack_require__(26);
	
	var _parse = __webpack_require__(6);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * Adds parallax to an element.
	 *
	 * Parallax with 75% speed: <div sw-parallax="0.75"></div>
	 * Parallax for background images: <div sw-parallax='{"scale": true}'></div>
	 *
	 * @param context
	 */
	function parallaxDirective() {
	    var context = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : document.body;
	
	    var $context = (0, _jquery2.default)(context);
	    var $window = (0, _jquery2.default)(window);
	
	    $context.find('[sw-parallax]').each(function () {
	        var $element = (0, _jquery2.default)(this);
	        var json = $element.attr('sw-parallax');
	        var settings = (0, _parse.directiveSettings)(json, {
	            speed: 0.5,
	            align: 0.5,
	            target: false,
	            scale: false
	        }, 'speed');
	
	        var $target = settings.target && !settings.scale ? (0, _jquery2.default)(settings.target) : false;
	
	        var height = void 0;
	        var offset = void 0;
	        var transform = void 0;
	
	        function setup() {
	            $element.css('transform', '');
	            $element.css('transform-origin', 'top center');
	
	            (0, _drawing.redraw)($element);
	
	            height = $element.outerHeight();
	            offset = $element.offset();
	
	            if (settings.scale) {
	                var viewHeight = Math.min((0, _window.getHeight)(), offset.top + height);
	                var newHeight = viewHeight - (viewHeight - height) * settings.speed;
	                transform = 'scale(' + newHeight / height + ')';
	            } else {
	                transform = '';
	            }
	
	            position();
	        }
	
	        function position() {
	            var targetHeight = $target ? $target.height() : (0, _window.getHeight)();
	            var scaleOffset = (targetHeight - height) * settings.align;
	            var translate = ((0, _window.getScrollTop)() - offset.top + scaleOffset) * (settings.speed - 1);
	
	            $element.css('transform', 'translate3d(0, ' + -translate + 'px, 0) ' + transform);
	        }
	
	        setup();
	        (0, _jquery2.default)(function () {
	            return (0, _drawing.frame)(setup);
	        });
	        $window.on('load resize', function () {
	            return (0, _drawing.frame)(setup);
	        });
	        $window.on('scroll', function () {
	            return (0, _drawing.frame)(position);
	        });
	    });
	}

/***/ }),
/* 31 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.default = revealDirective;
	
	var _jquery = __webpack_require__(3);
	
	var _jquery2 = _interopRequireDefault(_jquery);
	
	var _inspection = __webpack_require__(32);
	
	var _drawing = __webpack_require__(10);
	
	var _parse = __webpack_require__(6);
	
	var _window = __webpack_require__(26);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var $window = (0, _jquery2.default)(window);
	
	function revealDirective() {
	    var context = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : document.body;
	
	    var $context = (0, _jquery2.default)(context);
	    var $reveal = $context.find('[sw-reveal]');
	
	    if (!(0, _inspection.isTouch)()) {
	        var checkForReveal = function checkForReveal(element) {
	            var reset = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
	
	            var $this = (0, _jquery2.default)(element);
	            var isScrolled = $window.scrollTop() + $window.outerHeight() > $this.offset().top;
	            if (isScrolled && !$this.hasClass('is-revealed')) {
	                $this.addClass('is-revealed');
	            } else if (reset && !isScrolled && $this.hasClass('is-revealed')) {
	                $this.removeClass('is-revealed');
	            }
	        };
	
	        $reveal.each(function () {
	            var $element = (0, _jquery2.default)(this);
	            var json = $element.attr('sw-reveal');
	            var settings = (0, _parse.directiveSettings)(json, {
	                force: false,
	                reset: true
	            }, 'force');
	
	            if (!settings.force) {
	                $element.css('transition', 'none');
	            }
	
	            checkForReveal($element, settings.reset);
	
	            if (!settings.force) {
	                (0, _drawing.frame)(function () {
	                    return $element.css('transition', '');
	                });
	            }
	
	            (0, _window.onScroll)(function () {
	                return checkForReveal($element, settings.reset);
	            });
	        });
	    } else {
	
	        $reveal.css('transition', 'none');
	        $reveal.addClass('is-revealed');
	    }
	}

/***/ }),
/* 32 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.isTouch = isTouch;
	exports.isIE = isIE;
	exports.isSafari = isSafari;
	/**
	 * Crude check to see if the device is a touch screen.
	 * @see http://stackoverflow.com/a/4819886/556609
	 *
	 * @returns {boolean}
	 */
	function isTouch() {
	    return 'ontouchstart' in window || !!navigator.maxTouchPoints;
	}
	
	/**
	 * Crude check to see if the browser is IE.
	 *
	 * @param version - Optionally check a specific version (11, 10, or 9)
	 * @returns {boolean}
	 */
	function isIE() {
	    var version = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
	
	    var ua = navigator.userAgent;
	    var is11 = /rv:11\.0/i.test(ua);
	    var is10 = /MSIE 10/i.test(ua);
	    var is9 = /MSIE 9/i.test(ua);
	
	    switch (version) {
	        case 11:
	            return is11;
	        case 10:
	            return is10;
	        case 9:
	            return is9;
	    }
	
	    return is11 && is10 && is9;
	}
	
	/**
	 * Crude check to see if the browser is Safari.
	 *
	 * @returns {boolean}
	 */
	function isSafari() {
	    return (/^((?!chrome|android).)*safari/i.test(navigator.userAgent)
	    );
	}

/***/ }),
/* 33 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.default = stickyDirective;
	
	var _jquery = __webpack_require__(3);
	
	var _jquery2 = _interopRequireDefault(_jquery);
	
	var _parse = __webpack_require__(6);
	
	var _window = __webpack_require__(26);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * Sticks an element top the top of the screen.
	 * TODO Allow for a sticky container to stop elements sticking too far.
	 *
	 * @param context
	 */
	function stickyDirective() {
	    var context = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : document.body;
	
	    var $context = (0, _jquery2.default)(context);
	    var $window = (0, _jquery2.default)(window);
	
	    $context.find('[sw-sticky]').each(function () {
	        var $element = (0, _jquery2.default)(this);
	        var json = $element.attr('sw-sticky');
	        var settings = (0, _parse.directiveSettings)(json, {
	            name: '',
	            offset: 0
	        }, 'name');
	
	        var $filler = settings.name ? $context.find('[sw-sticky-filler=\'' + settings.name + '\']') : (0, _jquery2.default)();
	        if ($filler.length === 0) {
	            $filler = (0, _jquery2.default)('<div sw-sticky-filler="' + settings.name + '">');
	            $element.before($filler);
	        }
	
	        var isFixed = false;
	
	        function fillerSize() {
	            $filler.css('height', $element.outerHeight() + 'px');
	        }
	
	        function stickyScroll() {
	            if (isFixed) {
	                var fillerTop = $filler.offset().top + settings.offset;
	                if ((0, _window.getScrollTop)() <= fillerTop) {
	                    isFixed = false;
	                    fixSticky(false);
	                }
	            } else {
	                var stickyTop = $element.offset().top + settings.offset;
	                if ((0, _window.getScrollTop)() > stickyTop) {
	                    isFixed = true;
	                    fixSticky(true);
	                }
	            }
	        }
	
	        function fixSticky(fix) {
	            if (fix) {
	                $filler.css('display', '');
	                $element.addClass('is-stuck').removeClass('is-unstuck');
	            } else {
	                $filler.css('display', 'none');
	                $element.removeClass('is-stuck').addClass('is-unstuck');
	            }
	        }
	
	        fillerSize();
	        fixSticky(false);
	        stickyScroll();
	
	        $window.on('resize', fillerSize);
	        $window.on('resize scroll', stickyScroll);
	    });
	}

/***/ }),
/* 34 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.default = categorySelectDirective;
	
	var _jquery = __webpack_require__(3);
	
	var _jquery2 = _interopRequireDefault(_jquery);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function getParams(url) {
	    var paramsString = window.location.href.split('?')[1];
	    var paramsSplit = typeof paramsString !== 'undefined' ? paramsString.split('&') : null;
	    var params = [];
	
	    if (paramsSplit !== null) {
	        var _iteratorNormalCompletion = true;
	        var _didIteratorError = false;
	        var _iteratorError = undefined;
	
	        try {
	            for (var _iterator = paramsSplit[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
	                var param = _step.value;
	
	                var paramSplit = param.split('=');
	                params.push({
	                    name: paramSplit[0],
	                    value: paramSplit[1] || ''
	                });
	            }
	        } catch (err) {
	            _didIteratorError = true;
	            _iteratorError = err;
	        } finally {
	            try {
	                if (!_iteratorNormalCompletion && _iterator.return) {
	                    _iterator.return();
	                }
	            } finally {
	                if (_didIteratorError) {
	                    throw _iteratorError;
	                }
	            }
	        }
	    }
	
	    return params;
	}
	
	function categorySelectDirective() {
	    var context = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : document.body;
	
	    var siteUrl = (0, _jquery2.default)('.header_logo > a').attr('href');
	    var $context = (0, _jquery2.default)(context);
	
	    $context.find('[sw-category-select]').each(function () {
	        var $this = (0, _jquery2.default)(this);
	
	        $this.on('change', function (e) {
	            var newUri = $this.find('select').val();
	            var params = getParams(window.location.href);
	
	            var _iteratorNormalCompletion2 = true;
	            var _didIteratorError2 = false;
	            var _iteratorError2 = undefined;
	
	            try {
	                for (var _iterator2 = params[Symbol.iterator](), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
	                    var param = _step2.value;
	
	                    if (param.name === 'sort') {
	                        newUri += '?sort=' + param.value;
	                    }
	                }
	            } catch (err) {
	                _didIteratorError2 = true;
	                _iteratorError2 = err;
	            } finally {
	                try {
	                    if (!_iteratorNormalCompletion2 && _iterator2.return) {
	                        _iterator2.return();
	                    }
	                } finally {
	                    if (_didIteratorError2) {
	                        throw _iteratorError2;
	                    }
	                }
	            }
	
	            window.location.href = siteUrl + newUri;
	        });
	    });
	}

/***/ }),
/* 35 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.default = shopFormDirective;
	
	var _jquery = __webpack_require__(3);
	
	var _jquery2 = _interopRequireDefault(_jquery);
	
	var _init = __webpack_require__(1);
	
	var _init2 = _interopRequireDefault(_init);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function shopFormDirective() {
	    var context = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : document.body;
	
	    var $context = (0, _jquery2.default)(context);
	    var siteUrl = (0, _jquery2.default)('.header_logo > a').attr('href');
	    var $forms = $context.find('[sw-shop-form]');
	    var $cart = (0, _jquery2.default)('.cart');
	    var $cartBody = $cart.find('.cart_body');
	    var $cartButton = (0, _jquery2.default)('.header_cart-button');
	    var $cartCount = $cartButton.find('.header_cart-button_count');
	    var cartToggler = $cart.data('toggler');
	
	    $forms.on('submit', function (e) {
	        e.preventDefault();
	
	        var $this = (0, _jquery2.default)(this);
	        var data = $this.serialize();
	
	        _jquery2.default.post('', data, function (r) {
	            if (r.cart) {
	
	                // Update the quantity as seen on the cart button.
	                $cartCount.html('(' + r.cart.totalQty + ')');
	
	                // Update the cart body.
	                _jquery2.default.get(siteUrl + 'ajax/cart', '', function (c) {
	                    $cartBody.html(c);
	                    (0, _init2.default)($cartBody[0]);
	
	                    // Open the cart, if it isn't already.
	                    if (!cartToggler.isOpen) {
	                        cartToggler.open();
	                    }
	                });
	            } else {
	                console.log('Form submission failure. Query: ' + data);
	            }
	        }, 'json');
	    });
	}

/***/ }),
/* 36 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	exports.default = sortSelectDirective;
	
	var _jquery = __webpack_require__(3);
	
	var _jquery2 = _interopRequireDefault(_jquery);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function sortSelectDirective() {
		var context = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : document.body;
	
		var $context = (0, _jquery2.default)(context);
	
		var pageUrl = (0, _jquery2.default)('link[rel=canonical]').attr('href');
	
		$context.find('[sw-select-autoloader]').on('change', function (e) {
			var selectField = (0, _jquery2.default)(this).find('select')[0];
			var searchParams = Object.fromEntries(new URLSearchParams(window.location.search));
			searchParams[selectField.name] = selectField.value;
			window.location.href = window.location.pathname + '?' + new URLSearchParams(searchParams).toString();
		});
	}

/***/ }),
/* 37 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	exports.default = inspectScrollDirective;
	
	var _jquery = __webpack_require__(3);
	
	var _jquery2 = _interopRequireDefault(_jquery);
	
	var _parse = __webpack_require__(6);
	
	var _window = __webpack_require__(26);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function inspectScrollDirective() {
		var context = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : document.body;
	
		var $context = (0, _jquery2.default)(context);
	
		$context.find('[sw-inspect-scroll]').each(function () {
			var $element = (0, _jquery2.default)(this);
			var json = $element.attr('sw-inspect-scroll');
			var settings = (0, _parse.directiveSettings)(json, {
				target: null,
				class: 'is-scrollable',
				inverted: false
			}, 'target');
	
			var $target = settings.target ? (0, _jquery2.default)(settings.target) : $element;
	
			if ($target.length > 0) {
				(0, _window.onResize)(function () {
					var width = $target.width();
					var scrollWidth = $target[0].scrollWidth;
	
					var height = $target.height();
					var scrollHeight = $target[0].scrollHeight;
	
					var isScrolling = scrollWidth - width > 0 || scrollHeight - height > 0;
	
					$element.toggleClass(settings.class, settings.inverted ? !isScrolling : isScrolling);
				});
			}
		});
	}

/***/ }),
/* 38 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	exports.default = headerSection;
	
	var _jquery = __webpack_require__(3);
	
	var _jquery2 = _interopRequireDefault(_jquery);
	
	var _toggler = __webpack_require__(8);
	
	var _toggler2 = _interopRequireDefault(_toggler);
	
	var _window = __webpack_require__(26);
	
	var _drawing = __webpack_require__(10);
	
	var _init = __webpack_require__(1);
	
	var _init2 = _interopRequireDefault(_init);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function headerSection() {
		var $html = (0, _jquery2.default)('html');
		var $nav = (0, _jquery2.default)('#header-nav');
	
		(function initMenu() {
			var toggleDelay = 300;
	
			var $root = $nav.find('.header-nav_root');
			var $rootItems = $root.children('.-has-children');
			var $background = $nav.find('.header-nav_background');
	
			var $currentMenu = null;
			var currentToggler = null;
			var backgroundFrame = void 0;
			var timeout = void 0;
	
			function setBackgroundHeight() {
				if ($currentMenu) {
					$background.css('height', $currentMenu.outerHeight() + 'px');
					$html.addClass('is-header-open');
				} else {
					$background.css('height', '');
					$html.removeClass('is-header-open');
				}
			}
	
			$rootItems.each(function () {
				var $item = (0, _jquery2.default)(this);
				var $menu = $item.children('ul');
	
				var open = false;
				var transition = parseFloat($menu.css('transition-duration')) ? 'css' : false;
				var toggler = new _toggler2.default($menu, { open: open, transition: transition });
	
				function openMenu() {
					if ($currentMenu !== $menu) {
						toggler.open();
	
						if (currentToggler) {
							currentToggler.close();
						}
	
						$currentMenu = $menu;
						currentToggler = toggler;
	
						(0, _drawing.unframe)(backgroundFrame);
						setBackgroundHeight();
					}
				}
	
				function closeMenu() {
					if ($currentMenu === $menu) {
						toggler.close();
	
						$currentMenu = null;
						currentToggler = null;
	
						backgroundFrame = (0, _drawing.frame)(function () {
							return setBackgroundHeight();
						});
					}
				}
	
				$item.on('mouseover', function () {
					clearTimeout(timeout);
					if (currentToggler && currentToggler.isOpen) {
						openMenu();
					} else {
						timeout = setTimeout(openMenu, toggleDelay);
					}
				});
	
				$item.on('mouseout', function () {
					clearTimeout(timeout);
					timeout = setTimeout(closeMenu, toggleDelay);
				});
			});
	
			(0, _window.onResize)(setBackgroundHeight);
		})();
	
		(function initSearch() {
			var $search = $nav.find('.header-nav_search');
			var $searchField = $nav.find('.header-nav_search_field');
			var $searchButton = $search.find('.header-nav_search_button');
	
			var open = false;
			var transition = parseFloat($search.css('transition-duration')) ? 'css' : false;
			var toggler = new _toggler2.default($search, { open: open, transition: transition });
	
			toggler.on('open', function () {
				return $searchField.trigger('focus');
			});
			toggler.on('toggle', function () {
				return $nav.toggleClass('is-search-open', toggler.isOpen);
			});
	
			$searchButton.on('click', function (e) {
				if (!toggler.isOpen) {
					e.preventDefault();
					toggler.open();
				}
			});
	
			$search.on('click', function (e) {
				return e.stopPropagation();
			});
			$html.on('click', function () {
				return toggler.close();
			});
		})();
	
		(0, _jquery2.default)(function () {
			var siteUrl = (0, _jquery2.default)('.header_logo > a').attr('href');
			var $cart = (0, _jquery2.default)('.cart');
			var $cartBody = $cart.find('.cart_body');
			_jquery2.default.get(siteUrl + 'ajax/cart', '', function (c) {
				$cartBody.html(c);
				(0, _init2.default)($cartBody[0]);
			});
		});
	}

/***/ }),
/* 39 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	exports.default = modalSection;
	
	var _jquery = __webpack_require__(3);
	
	var _jquery2 = _interopRequireDefault(_jquery);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function modalSection() {
		var $html = (0, _jquery2.default)('html');
		var $modal = (0, _jquery2.default)('#modal');
		var $iframe = $modal.find('iframe');
		var toggler = $modal.data('toggler');
	
		function resetIframe() {
			$iframe.attr('src', '');
			$iframe.attr('src', 'about:blank');
		}
	
		if (toggler) {
	
			// $iframe.on('load', () => toggler.open());
			$iframe.on('load', function () {
				try {
					var href = $iframe[0].contentWindow.location.href;
					var isBlank = href === 'about:blank';
					toggler.toggle(!isBlank);
				} catch (e) {
					toggler.close();
				}
	
				// console.log('asdf');
			});
			$modal.on('click', function (e) {
				if (e.target === this) {
					toggler.close();
					resetIframe();
				}
			});
	
			toggler.on('toggle', function () {
				$html.toggleClass('is-modal-open', toggler.isOpen);
	
				if (toggler.isOpen == false) {
					resetIframe();
				}
			});
		}
	}

/***/ })
/******/ ]);


// WEBPACK FOOTER //
// main.js